var items = {
  "block.minecraft.acacia_button": "Botó d'acàcia",
  "block.minecraft.acacia_door": "Porta d'acàcia",
  "block.minecraft.acacia_fence": "Tanca d'acàcia",
  "block.minecraft.acacia_fence_gate": "Porta de tanca d'acàcia",
  "block.minecraft.acacia_hanging_sign": "Cartell d'acàcia penjant",
  "block.minecraft.acacia_leaves": "Fulles d'acàcia",
  "block.minecraft.acacia_log": "Tronc d'acàcia",
  "block.minecraft.acacia_planks": "Taulons d'acàcia",
  "block.minecraft.acacia_pressure_plate": "Placa de pressió d'acàcia",
  "block.minecraft.acacia_sapling": "Esqueix d'acàcia",
  "block.minecraft.acacia_shelf": "Prestatgeria d'acàcia",
  "block.minecraft.acacia_sign": "Cartell d'acàcia",
  "block.minecraft.acacia_slab": "Llosa d'acàcia",
  "block.minecraft.acacia_stairs": "Escales d'acàcia",
  "block.minecraft.acacia_trapdoor": "Trapa d'acàcia",
  "block.minecraft.acacia_wall_hanging_sign": "Cartell d'acàcia penjant de paret",
  "block.minecraft.acacia_wall_sign": "Cartell d'acàcia de paret",
  "block.minecraft.acacia_wood": "Llenya d'acàcia",
  "block.minecraft.activator_rail": "Via activadora",
  "block.minecraft.air": "Aire",
  "block.minecraft.allium": "Allium",
  "block.minecraft.amethyst_block": "Bloc d'ametista",
  "block.minecraft.amethyst_cluster": "Cúmul d'ametista",
  "block.minecraft.ancient_debris": "Enderrocs antics",
  "block.minecraft.andesite": "Andesita",
  "block.minecraft.andesite_slab": "Llosa d'andesita",
  "block.minecraft.andesite_stairs": "Escales d'andesita",
  "block.minecraft.andesite_wall": "Mur d'andesita",
  "block.minecraft.anvil": "Enclusa",
  "block.minecraft.attached_melon_stem": "Tija de meló d'Alger unida",
  "block.minecraft.attached_pumpkin_stem": "Tija de carabassa unida",
  "block.minecraft.azalea": "Azalea",
  "block.minecraft.azalea_leaves": "Fulles d'azalea",
  "block.minecraft.azure_bluet": "Houstonia caerulea",
  "block.minecraft.bamboo": "Bambú",
  "block.minecraft.bamboo_block": "Bloc de bambú",
  "block.minecraft.bamboo_button": "Botó de bambú",
  "block.minecraft.bamboo_door": "Porta de bambú",
  "block.minecraft.bamboo_fence": "Tanca de bambú",
  "block.minecraft.bamboo_fence_gate": "Porta de tanca de bambú",
  "block.minecraft.bamboo_hanging_sign": "Cartell de bambú penjant",
  "block.minecraft.bamboo_mosaic": "Mosaic de bambú",
  "block.minecraft.bamboo_mosaic_slab": "Llosa de mosaic de bambú",
  "block.minecraft.bamboo_mosaic_stairs": "Escales de mosaic de bambú",
  "block.minecraft.bamboo_planks": "Taulons de bambú",
  "block.minecraft.bamboo_pressure_plate": "Placa de pressió de bambú",
  "block.minecraft.bamboo_sapling": "Esqueix de bambú",
  "block.minecraft.bamboo_shelf": "Prestatgeria de bambú",
  "block.minecraft.bamboo_sign": "Cartell de bambú",
  "block.minecraft.bamboo_slab": "Llosa de bambú",
  "block.minecraft.bamboo_stairs": "Escales de bambú",
  "block.minecraft.bamboo_trapdoor": "Trapa de bambú",
  "block.minecraft.bamboo_wall_hanging_sign": "Cartell de bambú penjant de paret",
  "block.minecraft.bamboo_wall_sign": "Cartell de bambú de paret",
  "block.minecraft.banner.base.black": "Superfície negra",
  "block.minecraft.banner.base.blue": "Superfície blava",
  "block.minecraft.banner.base.brown": "Superfície marró",
  "block.minecraft.banner.base.cyan": "Superfície cian",
  "block.minecraft.banner.base.gray": "Superfície grisa",
  "block.minecraft.banner.base.green": "Superfície verda",
  "block.minecraft.banner.base.light_blue": "Superfície blava clara",
  "block.minecraft.banner.base.light_gray": "Superfície grisa clara",
  "block.minecraft.banner.base.lime": "Superfície verda llima",
  "block.minecraft.banner.base.magenta": "Superfície magenta",
  "block.minecraft.banner.base.orange": "Superfície taronja",
  "block.minecraft.banner.base.pink": "Superfície rosa",
  "block.minecraft.banner.base.purple": "Superfície morada",
  "block.minecraft.banner.base.red": "Superfície roja",
  "block.minecraft.banner.base.white": "Superfície blanca",
  "block.minecraft.banner.base.yellow": "Superfície groga",
  "block.minecraft.banner.border.black": "Bordura negra",
  "block.minecraft.banner.border.blue": "Bordura blava",
  "block.minecraft.banner.border.brown": "Bordura marró",
  "block.minecraft.banner.border.cyan": "Bordura cian",
  "block.minecraft.banner.border.gray": "Bordura grisa",
  "block.minecraft.banner.border.green": "Bordura verda",
  "block.minecraft.banner.border.light_blue": "Bordura blava clara",
  "block.minecraft.banner.border.light_gray": "Bordura grisa clara",
  "block.minecraft.banner.border.lime": "Bordura verda llima",
  "block.minecraft.banner.border.magenta": "Bordura magenta",
  "block.minecraft.banner.border.orange": "Bordura taronja",
  "block.minecraft.banner.border.pink": "Bordura rosa",
  "block.minecraft.banner.border.purple": "Bordura morada",
  "block.minecraft.banner.border.red": "Bordura roja",
  "block.minecraft.banner.border.white": "Bordura blanca",
  "block.minecraft.banner.border.yellow": "Bordura groga",
  "block.minecraft.banner.bricks.black": "Maçonat negre",
  "block.minecraft.banner.bricks.blue": "Maçonat blau",
  "block.minecraft.banner.bricks.brown": "Maçonat marró",
  "block.minecraft.banner.bricks.cyan": "Maçonat cian",
  "block.minecraft.banner.bricks.gray": "Maçonat gris",
  "block.minecraft.banner.bricks.green": "Maçonat verd",
  "block.minecraft.banner.bricks.light_blue": "Maçonat blau clar",
  "block.minecraft.banner.bricks.light_gray": "Maçonat gris clar",
  "block.minecraft.banner.bricks.lime": "Maçonat verd llima",
  "block.minecraft.banner.bricks.magenta": "Maçonat magenta",
  "block.minecraft.banner.bricks.orange": "Maçonat taronja",
  "block.minecraft.banner.bricks.pink": "Maçonat rosa",
  "block.minecraft.banner.bricks.purple": "Maçonat morat",
  "block.minecraft.banner.bricks.red": "Maçonat roig",
  "block.minecraft.banner.bricks.white": "Maçonat blanc",
  "block.minecraft.banner.bricks.yellow": "Maçonat groc",
  "block.minecraft.banner.circle.black": "Rodella negra",
  "block.minecraft.banner.circle.blue": "Rodella blava",
  "block.minecraft.banner.circle.brown": "Rodella marró",
  "block.minecraft.banner.circle.cyan": "Rodella cian",
  "block.minecraft.banner.circle.gray": "Rodella grisa",
  "block.minecraft.banner.circle.green": "Rodella verda",
  "block.minecraft.banner.circle.light_blue": "Rodella blava clara",
  "block.minecraft.banner.circle.light_gray": "Rodella grisa clara",
  "block.minecraft.banner.circle.lime": "Rodella verda llima",
  "block.minecraft.banner.circle.magenta": "Rodella magenta",
  "block.minecraft.banner.circle.orange": "Rodella taronja",
  "block.minecraft.banner.circle.pink": "Rodella rosa",
  "block.minecraft.banner.circle.purple": "Rodella morada",
  "block.minecraft.banner.circle.red": "Rodella roja",
  "block.minecraft.banner.circle.white": "Rodella blanca",
  "block.minecraft.banner.circle.yellow": "Rodella groga",
  "block.minecraft.banner.creeper.black": "Estampat de creeper negre",
  "block.minecraft.banner.creeper.blue": "Estampat de creeper blau",
  "block.minecraft.banner.creeper.brown": "Estampat de creeper marró",
  "block.minecraft.banner.creeper.cyan": "Estampat de creeper cian",
  "block.minecraft.banner.creeper.gray": "Estampat de creeper gris",
  "block.minecraft.banner.creeper.green": "Estampat de creeper verd",
  "block.minecraft.banner.creeper.light_blue": "Estampat de creeper blau clar",
  "block.minecraft.banner.creeper.light_gray": "Estampat de creeper gris clar",
  "block.minecraft.banner.creeper.lime": "Estampat de creeper verd llima",
  "block.minecraft.banner.creeper.magenta": "Estampat de creeper magenta",
  "block.minecraft.banner.creeper.orange": "Estampat de creeper taronja",
  "block.minecraft.banner.creeper.pink": "Estampat de creeper rosa",
  "block.minecraft.banner.creeper.purple": "Estampat de creeper morat",
  "block.minecraft.banner.creeper.red": "Estampat de creeper roig",
  "block.minecraft.banner.creeper.white": "Estampat de creeper blanc",
  "block.minecraft.banner.creeper.yellow": "Estampat de creeper groc",
  "block.minecraft.banner.cross.black": "Aspa negra",
  "block.minecraft.banner.cross.blue": "Aspa blava",
  "block.minecraft.banner.cross.brown": "Aspa marró",
  "block.minecraft.banner.cross.cyan": "Aspa cian",
  "block.minecraft.banner.cross.gray": "Aspa grisa",
  "block.minecraft.banner.cross.green": "Aspa verda",
  "block.minecraft.banner.cross.light_blue": "Aspa blava clara",
  "block.minecraft.banner.cross.light_gray": "Aspa grisa clara",
  "block.minecraft.banner.cross.lime": "Aspa verda llima",
  "block.minecraft.banner.cross.magenta": "Aspa magenta",
  "block.minecraft.banner.cross.orange": "Aspa taronja",
  "block.minecraft.banner.cross.pink": "Aspa rosa",
  "block.minecraft.banner.cross.purple": "Aspa morada",
  "block.minecraft.banner.cross.red": "Aspa roja",
  "block.minecraft.banner.cross.white": "Aspa blanca",
  "block.minecraft.banner.cross.yellow": "Aspa groga",
  "block.minecraft.banner.curly_border.black": "Bordura dentada negra",
  "block.minecraft.banner.curly_border.blue": "Bordura dentada blava",
  "block.minecraft.banner.curly_border.brown": "Bordura dentada marró",
  "block.minecraft.banner.curly_border.cyan": "Bordura dentada cian",
  "block.minecraft.banner.curly_border.gray": "Bordura dentada grisa",
  "block.minecraft.banner.curly_border.green": "Bordura dentada verda",
  "block.minecraft.banner.curly_border.light_blue": "Bordura dentada blava clara",
  "block.minecraft.banner.curly_border.light_gray": "Bordura dentada grisa clara",
  "block.minecraft.banner.curly_border.lime": "Bordura dentada verda llima",
  "block.minecraft.banner.curly_border.magenta": "Bordura dentada magenta",
  "block.minecraft.banner.curly_border.orange": "Bordura dentada taronja",
  "block.minecraft.banner.curly_border.pink": "Bordura dentada rosa",
  "block.minecraft.banner.curly_border.purple": "Bordura dentada morada",
  "block.minecraft.banner.curly_border.red": "Bordura dentada roja",
  "block.minecraft.banner.curly_border.white": "Bordura dentada blanca",
  "block.minecraft.banner.curly_border.yellow": "Bordura dentada groga",
  "block.minecraft.banner.diagonal_left.black": "Tallat negre a dret",
  "block.minecraft.banner.diagonal_left.blue": "Tallat blau a dret",
  "block.minecraft.banner.diagonal_left.brown": "Tallat marró a dret",
  "block.minecraft.banner.diagonal_left.cyan": "Tallat cian a dret",
  "block.minecraft.banner.diagonal_left.gray": "Tallat gris a dret",
  "block.minecraft.banner.diagonal_left.green": "Tallat verd a dret",
  "block.minecraft.banner.diagonal_left.light_blue": "Tallat blau clar a dret",
  "block.minecraft.banner.diagonal_left.light_gray": "Tallat gris clar a dret",
  "block.minecraft.banner.diagonal_left.lime": "Tallat verd llima a dret",
  "block.minecraft.banner.diagonal_left.magenta": "Tallat magenta a dret",
  "block.minecraft.banner.diagonal_left.orange": "Tallat taronja a dret",
  "block.minecraft.banner.diagonal_left.pink": "Tallat rosa a dret",
  "block.minecraft.banner.diagonal_left.purple": "Tallat morat a dret",
  "block.minecraft.banner.diagonal_left.red": "Tallat roig a dret",
  "block.minecraft.banner.diagonal_left.white": "Tallat blanc a dret",
  "block.minecraft.banner.diagonal_left.yellow": "Tallat groc a dret",
  "block.minecraft.banner.diagonal_right.black": "Tallat negre a tort",
  "block.minecraft.banner.diagonal_right.blue": "Tallat blau a tort",
  "block.minecraft.banner.diagonal_right.brown": "Tallat marró a tort",
  "block.minecraft.banner.diagonal_right.cyan": "Tallat cian a tort",
  "block.minecraft.banner.diagonal_right.gray": "Tallat gris a tort",
  "block.minecraft.banner.diagonal_right.green": "Tallat verd a tort",
  "block.minecraft.banner.diagonal_right.light_blue": "Tallat blau clar a tort",
  "block.minecraft.banner.diagonal_right.light_gray": "Tallat gris clar a tort",
  "block.minecraft.banner.diagonal_right.lime": "Tallat verd llima a tort",
  "block.minecraft.banner.diagonal_right.magenta": "Tallat magenta a tort",
  "block.minecraft.banner.diagonal_right.orange": "Tallat taronja a tort",
  "block.minecraft.banner.diagonal_right.pink": "Tallat rosa a tort",
  "block.minecraft.banner.diagonal_right.purple": "Tallat morat a tort",
  "block.minecraft.banner.diagonal_right.red": "Tallat roig a tort",
  "block.minecraft.banner.diagonal_right.white": "Tallat blanc a tort",
  "block.minecraft.banner.diagonal_right.yellow": "Tallat groc a tort",
  "block.minecraft.banner.diagonal_up_left.black": "Tallat invertit negre a destra",
  "block.minecraft.banner.diagonal_up_left.blue": "Tallat invertit blau a destra",
  "block.minecraft.banner.diagonal_up_left.brown": "Tallat invertit marró a destra",
  "block.minecraft.banner.diagonal_up_left.cyan": "Tallat invertit cian a destra",
  "block.minecraft.banner.diagonal_up_left.gray": "Tallat invertit gris a destra",
  "block.minecraft.banner.diagonal_up_left.green": "Tallat invertit verd a destra",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Tallat invertit blau clar a destra",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Tallat invertit gris clar a destra",
  "block.minecraft.banner.diagonal_up_left.lime": "Tallat invertit verd llima a destra",
  "block.minecraft.banner.diagonal_up_left.magenta": "Tallat invertit magenta a destra",
  "block.minecraft.banner.diagonal_up_left.orange": "Tallat invertit taronja a destra",
  "block.minecraft.banner.diagonal_up_left.pink": "Tallat invertit rosa a destra",
  "block.minecraft.banner.diagonal_up_left.purple": "Tallat invertit morat a destra",
  "block.minecraft.banner.diagonal_up_left.red": "Tallat invertit roig a destra",
  "block.minecraft.banner.diagonal_up_left.white": "Tallat invertit blanc a destra",
  "block.minecraft.banner.diagonal_up_left.yellow": "Tallat invertit groc a destra",
  "block.minecraft.banner.diagonal_up_right.black": "Tallat invertit negre a sinistra",
  "block.minecraft.banner.diagonal_up_right.blue": "Tallat invertit blau a sinistra",
  "block.minecraft.banner.diagonal_up_right.brown": "Tallat invertit marró a sinistra",
  "block.minecraft.banner.diagonal_up_right.cyan": "Tallat invertit cian a sinistra",
  "block.minecraft.banner.diagonal_up_right.gray": "Tallat invertit gris a sinistra",
  "block.minecraft.banner.diagonal_up_right.green": "Tallat invertit verd a sinistra",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Tallat invertit blau clar a sinistra",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Tallat invertit gris clar a sinistra",
  "block.minecraft.banner.diagonal_up_right.lime": "Tallat invertit verd llima a sinistra",
  "block.minecraft.banner.diagonal_up_right.magenta": "Tallat invertit magenta a sinistra",
  "block.minecraft.banner.diagonal_up_right.orange": "Tallat invertit taronja a sinistra",
  "block.minecraft.banner.diagonal_up_right.pink": "Tallat invertit rosa a sinistra",
  "block.minecraft.banner.diagonal_up_right.purple": "Tallat invertit morat a sinistra",
  "block.minecraft.banner.diagonal_up_right.red": "Tallat invertit roig a sinistra",
  "block.minecraft.banner.diagonal_up_right.white": "Tallat invertit blanc a sinistra",
  "block.minecraft.banner.diagonal_up_right.yellow": "Tallat invertit groc a sinistra",
  "block.minecraft.banner.flow.black": "Flux negre",
  "block.minecraft.banner.flow.blue": "Flux blau",
  "block.minecraft.banner.flow.brown": "Flux marró",
  "block.minecraft.banner.flow.cyan": "Flux cian",
  "block.minecraft.banner.flow.gray": "Flux gris",
  "block.minecraft.banner.flow.green": "Flux verd",
  "block.minecraft.banner.flow.light_blue": "Flux blau clar",
  "block.minecraft.banner.flow.light_gray": "Flux gris clar",
  "block.minecraft.banner.flow.lime": "Flux verd llima",
  "block.minecraft.banner.flow.magenta": "Flux magenta",
  "block.minecraft.banner.flow.orange": "Flux taronja",
  "block.minecraft.banner.flow.pink": "Flux rosa",
  "block.minecraft.banner.flow.purple": "Flux morat",
  "block.minecraft.banner.flow.red": "Flux roig",
  "block.minecraft.banner.flow.white": "Flux blanc",
  "block.minecraft.banner.flow.yellow": "Flux groc",
  "block.minecraft.banner.flower.black": "Estampat de flor negre",
  "block.minecraft.banner.flower.blue": "Estampat de flor blau",
  "block.minecraft.banner.flower.brown": "Estampat de flor marró",
  "block.minecraft.banner.flower.cyan": "Estampat de flor cian",
  "block.minecraft.banner.flower.gray": "Estampat de flor gris",
  "block.minecraft.banner.flower.green": "Estampat de flor verd",
  "block.minecraft.banner.flower.light_blue": "Estampat de flor blau clar",
  "block.minecraft.banner.flower.light_gray": "Estampat de flor gris clar",
  "block.minecraft.banner.flower.lime": "Estampat de flor verd llima",
  "block.minecraft.banner.flower.magenta": "Estampat de flor magenta",
  "block.minecraft.banner.flower.orange": "Estampat de flor taronja",
  "block.minecraft.banner.flower.pink": "Estampat de flor rosa",
  "block.minecraft.banner.flower.purple": "Estampat de flor morat",
  "block.minecraft.banner.flower.red": "Estampat de flor roig",
  "block.minecraft.banner.flower.white": "Estampat de flor blanc",
  "block.minecraft.banner.flower.yellow": "Estampat de flor groc",
  "block.minecraft.banner.globe.black": "Planeta negre",
  "block.minecraft.banner.globe.blue": "Planeta blau",
  "block.minecraft.banner.globe.brown": "Planeta marró",
  "block.minecraft.banner.globe.cyan": "Planeta cian",
  "block.minecraft.banner.globe.gray": "Planeta gris",
  "block.minecraft.banner.globe.green": "Planeta verd",
  "block.minecraft.banner.globe.light_blue": "Planeta blau clar",
  "block.minecraft.banner.globe.light_gray": "Planeta gris clar",
  "block.minecraft.banner.globe.lime": "Planeta verd llima",
  "block.minecraft.banner.globe.magenta": "Planeta magenta",
  "block.minecraft.banner.globe.orange": "Planeta taronja",
  "block.minecraft.banner.globe.pink": "Planeta rosa",
  "block.minecraft.banner.globe.purple": "Planeta morat",
  "block.minecraft.banner.globe.red": "Planeta roig",
  "block.minecraft.banner.globe.white": "Planeta blanc",
  "block.minecraft.banner.globe.yellow": "Planeta groc",
  "block.minecraft.banner.gradient.black": "Difuminat negre",
  "block.minecraft.banner.gradient.blue": "Difuminat blau",
  "block.minecraft.banner.gradient.brown": "Difuminat marró",
  "block.minecraft.banner.gradient.cyan": "Difuminat cian",
  "block.minecraft.banner.gradient.gray": "Difuminat gris",
  "block.minecraft.banner.gradient.green": "Difuminat verd",
  "block.minecraft.banner.gradient.light_blue": "Difuminat blau clar",
  "block.minecraft.banner.gradient.light_gray": "Difuminat gris clar",
  "block.minecraft.banner.gradient.lime": "Difuminat verd llima",
  "block.minecraft.banner.gradient.magenta": "Difuminat magenta",
  "block.minecraft.banner.gradient.orange": "Difuminat taronja",
  "block.minecraft.banner.gradient.pink": "Difuminat rosa",
  "block.minecraft.banner.gradient.purple": "Difuminat morat",
  "block.minecraft.banner.gradient.red": "Difuminat roig",
  "block.minecraft.banner.gradient.white": "Difuminat blanc",
  "block.minecraft.banner.gradient.yellow": "Difuminat groc",
  "block.minecraft.banner.gradient_up.black": "Difuminat negre des de la base",
  "block.minecraft.banner.gradient_up.blue": "Difuminat blau des de la base",
  "block.minecraft.banner.gradient_up.brown": "Difuminat marró des de la base",
  "block.minecraft.banner.gradient_up.cyan": "Difuminat cian des de la base",
  "block.minecraft.banner.gradient_up.gray": "Difuminat gris des de la base",
  "block.minecraft.banner.gradient_up.green": "Difuminat verd des de la base",
  "block.minecraft.banner.gradient_up.light_blue": "Difuminat blau clar des de la base",
  "block.minecraft.banner.gradient_up.light_gray": "Difuminat gris clar des de la base",
  "block.minecraft.banner.gradient_up.lime": "Difuminat verd llima des de la base",
  "block.minecraft.banner.gradient_up.magenta": "Difuminat magenta des de la base",
  "block.minecraft.banner.gradient_up.orange": "Difuminat taronja des de la base",
  "block.minecraft.banner.gradient_up.pink": "Difuminat rosa des de la base",
  "block.minecraft.banner.gradient_up.purple": "Difuminat morat des de la base",
  "block.minecraft.banner.gradient_up.red": "Difuminat roig des de la base",
  "block.minecraft.banner.gradient_up.white": "Difuminat blanc des de la base",
  "block.minecraft.banner.gradient_up.yellow": "Difuminat groc des de la base",
  "block.minecraft.banner.guster.black": "Ràfega negra",
  "block.minecraft.banner.guster.blue": "Ràfega blava",
  "block.minecraft.banner.guster.brown": "Ràfega marró",
  "block.minecraft.banner.guster.cyan": "Ràfega cian",
  "block.minecraft.banner.guster.gray": "Ràfega gris",
  "block.minecraft.banner.guster.green": "Ràfega verda",
  "block.minecraft.banner.guster.light_blue": "Ràfega blava clara",
  "block.minecraft.banner.guster.light_gray": "Ràfega grisa clara",
  "block.minecraft.banner.guster.lime": "Ràfega verda llima",
  "block.minecraft.banner.guster.magenta": "Ràfega magenta",
  "block.minecraft.banner.guster.orange": "Ràfega taronja",
  "block.minecraft.banner.guster.pink": "Ràfega rosa",
  "block.minecraft.banner.guster.purple": "Ràfega morada",
  "block.minecraft.banner.guster.red": "Ràfega roja",
  "block.minecraft.banner.guster.white": "Ràfega blanca",
  "block.minecraft.banner.guster.yellow": "Ràfega groga",
  "block.minecraft.banner.half_horizontal.black": "Meitat superior negra",
  "block.minecraft.banner.half_horizontal.blue": "Meitat superior blava",
  "block.minecraft.banner.half_horizontal.brown": "Meitat superior marró",
  "block.minecraft.banner.half_horizontal.cyan": "Meitat superior cian",
  "block.minecraft.banner.half_horizontal.gray": "Meitat superior grisa",
  "block.minecraft.banner.half_horizontal.green": "Meitat superior verda",
  "block.minecraft.banner.half_horizontal.light_blue": "Meitat superior blava clara",
  "block.minecraft.banner.half_horizontal.light_gray": "Meitat superior grisa clara",
  "block.minecraft.banner.half_horizontal.lime": "Meitat superior verda llima",
  "block.minecraft.banner.half_horizontal.magenta": "Meitat superior magenta",
  "block.minecraft.banner.half_horizontal.orange": "Meitat superior taronja",
  "block.minecraft.banner.half_horizontal.pink": "Meitat superior rosa",
  "block.minecraft.banner.half_horizontal.purple": "Meitat superior morada",
  "block.minecraft.banner.half_horizontal.red": "Meitat superior roja",
  "block.minecraft.banner.half_horizontal.white": "Meitat superior blanca",
  "block.minecraft.banner.half_horizontal.yellow": "Meitat superior groga",
  "block.minecraft.banner.half_horizontal_bottom.black": "Meitat inferior negra",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Meitat inferior blava",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Meitat inferior marró",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Meitat inferior cian",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Meitat inferior grisa",
  "block.minecraft.banner.half_horizontal_bottom.green": "Meitat inferior verda",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Meitat inferior blava clara",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Meitat inferior grisa clara",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Meitat inferior verda llima",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Meitat inferior magenta",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Meitat inferior taronja",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Meitat inferior rosa",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Meitat inferior morada",
  "block.minecraft.banner.half_horizontal_bottom.red": "Meitat inferior roja",
  "block.minecraft.banner.half_horizontal_bottom.white": "Meitat inferior blanca",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Meitat inferior groga",
  "block.minecraft.banner.half_vertical.black": "Flanc negre",
  "block.minecraft.banner.half_vertical.blue": "Flanc blau",
  "block.minecraft.banner.half_vertical.brown": "Flanc marró",
  "block.minecraft.banner.half_vertical.cyan": "Flanc cian",
  "block.minecraft.banner.half_vertical.gray": "Flanc gris",
  "block.minecraft.banner.half_vertical.green": "Flanc verd",
  "block.minecraft.banner.half_vertical.light_blue": "Flanc blau clar",
  "block.minecraft.banner.half_vertical.light_gray": "Flanc gris clar",
  "block.minecraft.banner.half_vertical.lime": "Flanc verd llima",
  "block.minecraft.banner.half_vertical.magenta": "Flanc magenta",
  "block.minecraft.banner.half_vertical.orange": "Flanc taronja",
  "block.minecraft.banner.half_vertical.pink": "Flanc rosa",
  "block.minecraft.banner.half_vertical.purple": "Flanc morat",
  "block.minecraft.banner.half_vertical.red": "Flanc roig",
  "block.minecraft.banner.half_vertical.white": "Flanc blanc",
  "block.minecraft.banner.half_vertical.yellow": "Flanc groc",
  "block.minecraft.banner.half_vertical_right.black": "Flanc negre invertit",
  "block.minecraft.banner.half_vertical_right.blue": "Flanc blau invertit",
  "block.minecraft.banner.half_vertical_right.brown": "Flanc marró invertit",
  "block.minecraft.banner.half_vertical_right.cyan": "Flanc cian invertit",
  "block.minecraft.banner.half_vertical_right.gray": "Flanc gris invertit",
  "block.minecraft.banner.half_vertical_right.green": "Flanc verd invertit",
  "block.minecraft.banner.half_vertical_right.light_blue": "Flanc blau clar invertit",
  "block.minecraft.banner.half_vertical_right.light_gray": "Flanc gris clar invertit",
  "block.minecraft.banner.half_vertical_right.lime": "Flanc verd llima invertit",
  "block.minecraft.banner.half_vertical_right.magenta": "Flanc magenta invertit",
  "block.minecraft.banner.half_vertical_right.orange": "Flanc taronja invertit",
  "block.minecraft.banner.half_vertical_right.pink": "Flanc rosa invertit",
  "block.minecraft.banner.half_vertical_right.purple": "Flanc morat invertit",
  "block.minecraft.banner.half_vertical_right.red": "Flanc roig invertit",
  "block.minecraft.banner.half_vertical_right.white": "Flanc blanc invertit",
  "block.minecraft.banner.half_vertical_right.yellow": "Flanc groc invertit",
  "block.minecraft.banner.mojang.black": "Cosa negra",
  "block.minecraft.banner.mojang.blue": "Cosa blava",
  "block.minecraft.banner.mojang.brown": "Cosa marró",
  "block.minecraft.banner.mojang.cyan": "Cosa cian",
  "block.minecraft.banner.mojang.gray": "Cosa grisa",
  "block.minecraft.banner.mojang.green": "Cosa verda",
  "block.minecraft.banner.mojang.light_blue": "Cosa blava clara",
  "block.minecraft.banner.mojang.light_gray": "Cosa grisa clara",
  "block.minecraft.banner.mojang.lime": "Cosa verda llima",
  "block.minecraft.banner.mojang.magenta": "Cosa magenta",
  "block.minecraft.banner.mojang.orange": "Cosa taronja",
  "block.minecraft.banner.mojang.pink": "Cosa rosa",
  "block.minecraft.banner.mojang.purple": "Cosa morada",
  "block.minecraft.banner.mojang.red": "Cosa roja",
  "block.minecraft.banner.mojang.white": "Cosa blanca",
  "block.minecraft.banner.mojang.yellow": "Cosa groga",
  "block.minecraft.banner.piglin.black": "Morro negre",
  "block.minecraft.banner.piglin.blue": "Morro blau",
  "block.minecraft.banner.piglin.brown": "Morro marró",
  "block.minecraft.banner.piglin.cyan": "Morro cian",
  "block.minecraft.banner.piglin.gray": "Morro gris",
  "block.minecraft.banner.piglin.green": "Morro verd",
  "block.minecraft.banner.piglin.light_blue": "Morro blau clar",
  "block.minecraft.banner.piglin.light_gray": "Morro gris clar",
  "block.minecraft.banner.piglin.lime": "Morro verd llima",
  "block.minecraft.banner.piglin.magenta": "Morro magenta",
  "block.minecraft.banner.piglin.orange": "Morro taronja",
  "block.minecraft.banner.piglin.pink": "Morro rosa",
  "block.minecraft.banner.piglin.purple": "Morro morat",
  "block.minecraft.banner.piglin.red": "Morro roig",
  "block.minecraft.banner.piglin.white": "Morro blanc",
  "block.minecraft.banner.piglin.yellow": "Morro groc",
  "block.minecraft.banner.rhombus.black": "Rombe negre",
  "block.minecraft.banner.rhombus.blue": "Rombe blau",
  "block.minecraft.banner.rhombus.brown": "Rombe marró",
  "block.minecraft.banner.rhombus.cyan": "Rombe cian",
  "block.minecraft.banner.rhombus.gray": "Rombe gris",
  "block.minecraft.banner.rhombus.green": "Rombe verd",
  "block.minecraft.banner.rhombus.light_blue": "Rombe blau clar",
  "block.minecraft.banner.rhombus.light_gray": "Rombe gris clar",
  "block.minecraft.banner.rhombus.lime": "Rombe verd llima",
  "block.minecraft.banner.rhombus.magenta": "Rombe magenta",
  "block.minecraft.banner.rhombus.orange": "Rombe taronja",
  "block.minecraft.banner.rhombus.pink": "Rombe rosa",
  "block.minecraft.banner.rhombus.purple": "Rombe morat",
  "block.minecraft.banner.rhombus.red": "Rombe roig",
  "block.minecraft.banner.rhombus.white": "Rombe blanc",
  "block.minecraft.banner.rhombus.yellow": "Rombe groc",
  "block.minecraft.banner.skull.black": "Estampat de calavera negre",
  "block.minecraft.banner.skull.blue": "Estampat de calavera blau",
  "block.minecraft.banner.skull.brown": "Estampat de calavera marró",
  "block.minecraft.banner.skull.cyan": "Estampat de calavera cian",
  "block.minecraft.banner.skull.gray": "Estampat de calavera gris",
  "block.minecraft.banner.skull.green": "Estampat de calavera verd",
  "block.minecraft.banner.skull.light_blue": "Estampat de calavera blau clar",
  "block.minecraft.banner.skull.light_gray": "Estampat de calavera gris clar",
  "block.minecraft.banner.skull.lime": "Estampat de calavera verd llima",
  "block.minecraft.banner.skull.magenta": "Estampat de calavera magenta",
  "block.minecraft.banner.skull.orange": "Estampat de calavera taronja",
  "block.minecraft.banner.skull.pink": "Estampat de calavera rosa",
  "block.minecraft.banner.skull.purple": "Estampat de calavera morat",
  "block.minecraft.banner.skull.red": "Estampat de calavera roig",
  "block.minecraft.banner.skull.white": "Estampat de calavera blanc",
  "block.minecraft.banner.skull.yellow": "Estampat de calavera groc",
  "block.minecraft.banner.small_stripes.black": "Quadribarrada negra",
  "block.minecraft.banner.small_stripes.blue": "Quadribarrada blava",
  "block.minecraft.banner.small_stripes.brown": "Quadribarrada marró",
  "block.minecraft.banner.small_stripes.cyan": "Quadribarrada cian",
  "block.minecraft.banner.small_stripes.gray": "Quadribarrada grisa",
  "block.minecraft.banner.small_stripes.green": "Quadribarrada verda",
  "block.minecraft.banner.small_stripes.light_blue": "Quadribarrada blava clara",
  "block.minecraft.banner.small_stripes.light_gray": "Quadribarrada grisa clara",
  "block.minecraft.banner.small_stripes.lime": "Quadribarrada verda llima",
  "block.minecraft.banner.small_stripes.magenta": "Quadribarrada magenta",
  "block.minecraft.banner.small_stripes.orange": "Quadribarrada taronja",
  "block.minecraft.banner.small_stripes.pink": "Quadribarrada rosa",
  "block.minecraft.banner.small_stripes.purple": "Quadribarrada morada",
  "block.minecraft.banner.small_stripes.red": "Quadribarrada roja",
  "block.minecraft.banner.small_stripes.white": "Quadribarrada blanca",
  "block.minecraft.banner.small_stripes.yellow": "Quadribarrada groga",
  "block.minecraft.banner.square_bottom_left.black": "Cantó negre a la part inferior esquerra",
  "block.minecraft.banner.square_bottom_left.blue": "Cantó blau a la part inferior esquerra",
  "block.minecraft.banner.square_bottom_left.brown": "Cantó marró a la part inferior esquerra",
  "block.minecraft.banner.square_bottom_left.cyan": "Cantó cian a la part inferior esquerra",
  "block.minecraft.banner.square_bottom_left.gray": "Cantó gris a la part inferior esquerra",
  "block.minecraft.banner.square_bottom_left.green": "Cantó verd a la part inferior esquerra",
  "block.minecraft.banner.square_bottom_left.light_blue": "Cantó blau clar a la part inferior esquerra",
  "block.minecraft.banner.square_bottom_left.light_gray": "Cantó gris clar a la part inferior esquerra",
  "block.minecraft.banner.square_bottom_left.lime": "Cantó verd llima a la part inferior esquerra",
  "block.minecraft.banner.square_bottom_left.magenta": "Cantó magenta a la part inferior esquerra",
  "block.minecraft.banner.square_bottom_left.orange": "Cantó taronja a la part inferior esquerra",
  "block.minecraft.banner.square_bottom_left.pink": "Cantó rosa a la part inferior esquerra",
  "block.minecraft.banner.square_bottom_left.purple": "Cantó morat a la part inferior esquerra",
  "block.minecraft.banner.square_bottom_left.red": "Cantó roig a la part inferior esquerra",
  "block.minecraft.banner.square_bottom_left.white": "Cantó blanc a la part inferior esquerra",
  "block.minecraft.banner.square_bottom_left.yellow": "Cantó groc a la part inferior esquerra",
  "block.minecraft.banner.square_bottom_right.black": "Cantó negre a la part inferior dreta",
  "block.minecraft.banner.square_bottom_right.blue": "Cantó blau a la part inferior dreta",
  "block.minecraft.banner.square_bottom_right.brown": "Cantó marró a la part inferior dreta",
  "block.minecraft.banner.square_bottom_right.cyan": "Cantó cian a la part inferior dreta",
  "block.minecraft.banner.square_bottom_right.gray": "Cantó gris a la part inferior dreta",
  "block.minecraft.banner.square_bottom_right.green": "Cantó verd a la part inferior dreta",
  "block.minecraft.banner.square_bottom_right.light_blue": "Cantó blau clar a la part inferior dreta",
  "block.minecraft.banner.square_bottom_right.light_gray": "Cantó gris clar a la part inferior dreta",
  "block.minecraft.banner.square_bottom_right.lime": "Cantó verd llima a la part inferior dreta",
  "block.minecraft.banner.square_bottom_right.magenta": "Cantó magenta a la part inferior dreta",
  "block.minecraft.banner.square_bottom_right.orange": "Cantó taronja a la part inferior dreta",
  "block.minecraft.banner.square_bottom_right.pink": "Cantó rosa a la part inferior dreta",
  "block.minecraft.banner.square_bottom_right.purple": "Cantó morat a la part inferior dreta",
  "block.minecraft.banner.square_bottom_right.red": "Cantó roig a la part inferior dreta",
  "block.minecraft.banner.square_bottom_right.white": "Cantó blanc a la part inferior dreta",
  "block.minecraft.banner.square_bottom_right.yellow": "Cantó groc a la part inferior dreta",
  "block.minecraft.banner.square_top_left.black": "Cantó negre a la part superior esquerra",
  "block.minecraft.banner.square_top_left.blue": "Cantó blau a la part superior esquerra",
  "block.minecraft.banner.square_top_left.brown": "Cantó marró a la part superior esquerra",
  "block.minecraft.banner.square_top_left.cyan": "Cantó cian a la part superior esquerra",
  "block.minecraft.banner.square_top_left.gray": "Cantó gris a la part superior esquerra",
  "block.minecraft.banner.square_top_left.green": "Cantó verd a la part superior esquerra",
  "block.minecraft.banner.square_top_left.light_blue": "Cantó blau clar a la part superior esquerra",
  "block.minecraft.banner.square_top_left.light_gray": "Cantó gris clar a la part superior esquerra",
  "block.minecraft.banner.square_top_left.lime": "Cantó verd llima a la part superior esquerra",
  "block.minecraft.banner.square_top_left.magenta": "Cantó magenta a la part superior esquerra",
  "block.minecraft.banner.square_top_left.orange": "Cantó taronja a la part superior esquerra",
  "block.minecraft.banner.square_top_left.pink": "Cantó rosa a la part superior esquerra",
  "block.minecraft.banner.square_top_left.purple": "Cantó morat a la part superior esquerra",
  "block.minecraft.banner.square_top_left.red": "Cantó roig a la part superior esquerra",
  "block.minecraft.banner.square_top_left.white": "Cantó blanc a la part superior esquerra",
  "block.minecraft.banner.square_top_left.yellow": "Cantó groc a la part superior esquerra",
  "block.minecraft.banner.square_top_right.black": "Cantó negre a la part superior dreta",
  "block.minecraft.banner.square_top_right.blue": "Cantó blau a la part superior dreta",
  "block.minecraft.banner.square_top_right.brown": "Cantó marró a la part superior dreta",
  "block.minecraft.banner.square_top_right.cyan": "Cantó cian a la part superior dreta",
  "block.minecraft.banner.square_top_right.gray": "Cantó gris a la part superior dreta",
  "block.minecraft.banner.square_top_right.green": "Cantó verd a la part superior dreta",
  "block.minecraft.banner.square_top_right.light_blue": "Cantó blau clar a la part superior dreta",
  "block.minecraft.banner.square_top_right.light_gray": "Cantó gris clar a la part superior dreta",
  "block.minecraft.banner.square_top_right.lime": "Cantó verd llima a la part superior dreta",
  "block.minecraft.banner.square_top_right.magenta": "Cantó magenta a la part superior dreta",
  "block.minecraft.banner.square_top_right.orange": "Cantó taronja a la part superior dreta",
  "block.minecraft.banner.square_top_right.pink": "Cantó rosa a la part superior dreta",
  "block.minecraft.banner.square_top_right.purple": "Cantó morat a la part superior dreta",
  "block.minecraft.banner.square_top_right.red": "Cantó roig a la part superior dreta",
  "block.minecraft.banner.square_top_right.white": "Cantó blanc a la part superior dreta",
  "block.minecraft.banner.square_top_right.yellow": "Cantó groc a la part superior dreta",
  "block.minecraft.banner.straight_cross.black": "Creu negra",
  "block.minecraft.banner.straight_cross.blue": "Creu blava",
  "block.minecraft.banner.straight_cross.brown": "Creu marró",
  "block.minecraft.banner.straight_cross.cyan": "Creu cian",
  "block.minecraft.banner.straight_cross.gray": "Creu grisa",
  "block.minecraft.banner.straight_cross.green": "Creu verda",
  "block.minecraft.banner.straight_cross.light_blue": "Creu blava clara",
  "block.minecraft.banner.straight_cross.light_gray": "Creu grisa clara",
  "block.minecraft.banner.straight_cross.lime": "Creu verda llima",
  "block.minecraft.banner.straight_cross.magenta": "Creu magenta",
  "block.minecraft.banner.straight_cross.orange": "Creu taronja",
  "block.minecraft.banner.straight_cross.pink": "Creu rosa",
  "block.minecraft.banner.straight_cross.purple": "Creu morada",
  "block.minecraft.banner.straight_cross.red": "Creu roja",
  "block.minecraft.banner.straight_cross.white": "Creu blanca",
  "block.minecraft.banner.straight_cross.yellow": "Creu groga",
  "block.minecraft.banner.stripe_bottom.black": "Base negra",
  "block.minecraft.banner.stripe_bottom.blue": "Base blava",
  "block.minecraft.banner.stripe_bottom.brown": "Base marró",
  "block.minecraft.banner.stripe_bottom.cyan": "Base cian",
  "block.minecraft.banner.stripe_bottom.gray": "Base grisa",
  "block.minecraft.banner.stripe_bottom.green": "Base verda",
  "block.minecraft.banner.stripe_bottom.light_blue": "Base blava clara",
  "block.minecraft.banner.stripe_bottom.light_gray": "Base grisa clara",
  "block.minecraft.banner.stripe_bottom.lime": "Base verda llima",
  "block.minecraft.banner.stripe_bottom.magenta": "Base magenta",
  "block.minecraft.banner.stripe_bottom.orange": "Base taronja",
  "block.minecraft.banner.stripe_bottom.pink": "Base rosa",
  "block.minecraft.banner.stripe_bottom.purple": "Base morada",
  "block.minecraft.banner.stripe_bottom.red": "Base roja",
  "block.minecraft.banner.stripe_bottom.white": "Base blanca",
  "block.minecraft.banner.stripe_bottom.yellow": "Base groga",
  "block.minecraft.banner.stripe_center.black": "Franja vertical central negra",
  "block.minecraft.banner.stripe_center.blue": "Franja vertical central blava",
  "block.minecraft.banner.stripe_center.brown": "Franja vertical central marró",
  "block.minecraft.banner.stripe_center.cyan": "Franja vertical central cian",
  "block.minecraft.banner.stripe_center.gray": "Franja vertical central grisa",
  "block.minecraft.banner.stripe_center.green": "Franja vertical central verda",
  "block.minecraft.banner.stripe_center.light_blue": "Franja vertical central blava clara",
  "block.minecraft.banner.stripe_center.light_gray": "Franja vertical central grisa clara",
  "block.minecraft.banner.stripe_center.lime": "Franja vertical central verda llima",
  "block.minecraft.banner.stripe_center.magenta": "Franja vertical central magenta",
  "block.minecraft.banner.stripe_center.orange": "Franja vertical central taronja",
  "block.minecraft.banner.stripe_center.pink": "Franja vertical central rosa",
  "block.minecraft.banner.stripe_center.purple": "Franja vertical central morada",
  "block.minecraft.banner.stripe_center.red": "Franja vertical central roja",
  "block.minecraft.banner.stripe_center.white": "Franja vertical central blanca",
  "block.minecraft.banner.stripe_center.yellow": "Franja vertical central groga",
  "block.minecraft.banner.stripe_downleft.black": "Banda negra a dret",
  "block.minecraft.banner.stripe_downleft.blue": "Banda blava a dret",
  "block.minecraft.banner.stripe_downleft.brown": "Banda marró a dret",
  "block.minecraft.banner.stripe_downleft.cyan": "Banda cian a dret",
  "block.minecraft.banner.stripe_downleft.gray": "Banda grisa a dret",
  "block.minecraft.banner.stripe_downleft.green": "Banda verda a dret",
  "block.minecraft.banner.stripe_downleft.light_blue": "Banda blava clara a dret",
  "block.minecraft.banner.stripe_downleft.light_gray": "Banda grisa clara a dret",
  "block.minecraft.banner.stripe_downleft.lime": "Banda verda llima a dret",
  "block.minecraft.banner.stripe_downleft.magenta": "Banda magenta a dret",
  "block.minecraft.banner.stripe_downleft.orange": "Banda taronja a dret",
  "block.minecraft.banner.stripe_downleft.pink": "Banda rosa a dret",
  "block.minecraft.banner.stripe_downleft.purple": "Banda morada a dret",
  "block.minecraft.banner.stripe_downleft.red": "Banda roja a dret",
  "block.minecraft.banner.stripe_downleft.white": "Banda blanca a dret",
  "block.minecraft.banner.stripe_downleft.yellow": "Banda groga a dret",
  "block.minecraft.banner.stripe_downright.black": "Banda negra",
  "block.minecraft.banner.stripe_downright.blue": "Banda blava",
  "block.minecraft.banner.stripe_downright.brown": "Banda marró",
  "block.minecraft.banner.stripe_downright.cyan": "Banda cian",
  "block.minecraft.banner.stripe_downright.gray": "Banda grisa",
  "block.minecraft.banner.stripe_downright.green": "Banda verda",
  "block.minecraft.banner.stripe_downright.light_blue": "Banda blava clara",
  "block.minecraft.banner.stripe_downright.light_gray": "Banda grisa clara",
  "block.minecraft.banner.stripe_downright.lime": "Banda verda llima",
  "block.minecraft.banner.stripe_downright.magenta": "Banda magenta",
  "block.minecraft.banner.stripe_downright.orange": "Banda taronja",
  "block.minecraft.banner.stripe_downright.pink": "Banda rosa",
  "block.minecraft.banner.stripe_downright.purple": "Banda morada",
  "block.minecraft.banner.stripe_downright.red": "Banda roja",
  "block.minecraft.banner.stripe_downright.white": "Banda blanca",
  "block.minecraft.banner.stripe_downright.yellow": "Banda groga",
  "block.minecraft.banner.stripe_left.black": "Franja vertical negra a la part esquerra",
  "block.minecraft.banner.stripe_left.blue": "Franja vertical blava a la part esquerra",
  "block.minecraft.banner.stripe_left.brown": "Franja vertical marró a la part esquerra",
  "block.minecraft.banner.stripe_left.cyan": "Franja vertical cian a la part esquerra",
  "block.minecraft.banner.stripe_left.gray": "Franja vertical grisa a la part esquerra",
  "block.minecraft.banner.stripe_left.green": "Franja vertical verda a la part esquerra",
  "block.minecraft.banner.stripe_left.light_blue": "Franja vertical blava clara a la part esquerra",
  "block.minecraft.banner.stripe_left.light_gray": "Franja vertical grisa clara a la part esquerra",
  "block.minecraft.banner.stripe_left.lime": "Franja vertical verda llima a la part esquerra",
  "block.minecraft.banner.stripe_left.magenta": "Franja vertical magenta a la part esquerra",
  "block.minecraft.banner.stripe_left.orange": "Franja vertical taronja a la part esquerra",
  "block.minecraft.banner.stripe_left.pink": "Franja vertical rosa a la part esquerra",
  "block.minecraft.banner.stripe_left.purple": "Franja vertical morada a la part esquerra",
  "block.minecraft.banner.stripe_left.red": "Franja vertical roja a la part esquerra",
  "block.minecraft.banner.stripe_left.white": "Franja vertical blanca a la part esquerra",
  "block.minecraft.banner.stripe_left.yellow": "Franja vertical groga a la part esquerra",
  "block.minecraft.banner.stripe_middle.black": "Franja horitzontal central negra",
  "block.minecraft.banner.stripe_middle.blue": "Franja horitzontal central blava",
  "block.minecraft.banner.stripe_middle.brown": "Franja horitzontal central marró",
  "block.minecraft.banner.stripe_middle.cyan": "Franja horitzontal central cian",
  "block.minecraft.banner.stripe_middle.gray": "Franja horitzontal central grisa",
  "block.minecraft.banner.stripe_middle.green": "Franja horitzontal central verda",
  "block.minecraft.banner.stripe_middle.light_blue": "Franja horitzontal central blava clara",
  "block.minecraft.banner.stripe_middle.light_gray": "Franja horitzontal central grisa clara",
  "block.minecraft.banner.stripe_middle.lime": "Franja horitzontal central verda llima",
  "block.minecraft.banner.stripe_middle.magenta": "Franja horitzontal central magenta",
  "block.minecraft.banner.stripe_middle.orange": "Franja horitzontal central taronja",
  "block.minecraft.banner.stripe_middle.pink": "Franja horitzontal central rosa",
  "block.minecraft.banner.stripe_middle.purple": "Franja horitzontal central morada",
  "block.minecraft.banner.stripe_middle.red": "Franja horitzontal central roja",
  "block.minecraft.banner.stripe_middle.white": "Franja horitzontal central blanca",
  "block.minecraft.banner.stripe_middle.yellow": "Franja horitzontal central groga",
  "block.minecraft.banner.stripe_right.black": "Franja vertical negra a la part dreta",
  "block.minecraft.banner.stripe_right.blue": "Franja vertical blava a la part dreta",
  "block.minecraft.banner.stripe_right.brown": "Franja vertical marró a la part dreta",
  "block.minecraft.banner.stripe_right.cyan": "Franja vertical cian a la part dreta",
  "block.minecraft.banner.stripe_right.gray": "Franja vertical grisa a la part dreta",
  "block.minecraft.banner.stripe_right.green": "Franja vertical verda a la part dreta",
  "block.minecraft.banner.stripe_right.light_blue": "Franja vertical blava clara a la part dreta",
  "block.minecraft.banner.stripe_right.light_gray": "Franja vertical grisa clara a la part dreta",
  "block.minecraft.banner.stripe_right.lime": "Franja vertical verda llima a la part dreta",
  "block.minecraft.banner.stripe_right.magenta": "Franja vertical magenta a la part dreta",
  "block.minecraft.banner.stripe_right.orange": "Franja vertical taronja a la part dreta",
  "block.minecraft.banner.stripe_right.pink": "Franja vertical rosa a la part dreta",
  "block.minecraft.banner.stripe_right.purple": "Franja vertical morada a la part dreta",
  "block.minecraft.banner.stripe_right.red": "Franja vertical roja a la part dreta",
  "block.minecraft.banner.stripe_right.white": "Franja vertical blanca a la part dreta",
  "block.minecraft.banner.stripe_right.yellow": "Franja vertical groga a la part dreta",
  "block.minecraft.banner.stripe_top.black": "Cap negre",
  "block.minecraft.banner.stripe_top.blue": "Cap blau",
  "block.minecraft.banner.stripe_top.brown": "Cap marró",
  "block.minecraft.banner.stripe_top.cyan": "Cap cian",
  "block.minecraft.banner.stripe_top.gray": "Cap gris",
  "block.minecraft.banner.stripe_top.green": "Cap verd",
  "block.minecraft.banner.stripe_top.light_blue": "Cap blau clar",
  "block.minecraft.banner.stripe_top.light_gray": "Cap gris clar",
  "block.minecraft.banner.stripe_top.lime": "Cap verd llima",
  "block.minecraft.banner.stripe_top.magenta": "Cap magenta",
  "block.minecraft.banner.stripe_top.orange": "Cap taronja",
  "block.minecraft.banner.stripe_top.pink": "Cap rosa",
  "block.minecraft.banner.stripe_top.purple": "Cap morat",
  "block.minecraft.banner.stripe_top.red": "Cap roig",
  "block.minecraft.banner.stripe_top.white": "Cap blanc",
  "block.minecraft.banner.stripe_top.yellow": "Cap groc",
  "block.minecraft.banner.triangle_bottom.black": "Bou negre",
  "block.minecraft.banner.triangle_bottom.blue": "Bou blau",
  "block.minecraft.banner.triangle_bottom.brown": "Bou marró",
  "block.minecraft.banner.triangle_bottom.cyan": "Bou cian",
  "block.minecraft.banner.triangle_bottom.gray": "Bou gris",
  "block.minecraft.banner.triangle_bottom.green": "Bou verd",
  "block.minecraft.banner.triangle_bottom.light_blue": "Bou blau clar",
  "block.minecraft.banner.triangle_bottom.light_gray": "Bou gris clar",
  "block.minecraft.banner.triangle_bottom.lime": "Bou llima",
  "block.minecraft.banner.triangle_bottom.magenta": "Bou magenta",
  "block.minecraft.banner.triangle_bottom.orange": "Bou taronja",
  "block.minecraft.banner.triangle_bottom.pink": "Bou rosa",
  "block.minecraft.banner.triangle_bottom.purple": "Bou morat",
  "block.minecraft.banner.triangle_bottom.red": "Bou roig",
  "block.minecraft.banner.triangle_bottom.white": "Bou blanc",
  "block.minecraft.banner.triangle_bottom.yellow": "Bou groc",
  "block.minecraft.banner.triangle_top.black": "Bou invertit negre",
  "block.minecraft.banner.triangle_top.blue": "Bou invertit blau",
  "block.minecraft.banner.triangle_top.brown": "Bou invertit marró",
  "block.minecraft.banner.triangle_top.cyan": "Bou invertit cian",
  "block.minecraft.banner.triangle_top.gray": "Bou invertit gris",
  "block.minecraft.banner.triangle_top.green": "Bou invertit verd",
  "block.minecraft.banner.triangle_top.light_blue": "Bou invertit blau clar",
  "block.minecraft.banner.triangle_top.light_gray": "Bou invertit gris clar",
  "block.minecraft.banner.triangle_top.lime": "Bou invertit verd llima",
  "block.minecraft.banner.triangle_top.magenta": "Bou invertit magenta",
  "block.minecraft.banner.triangle_top.orange": "Bou invertit taronja",
  "block.minecraft.banner.triangle_top.pink": "Bou invertit rosa",
  "block.minecraft.banner.triangle_top.purple": "Bou invertit morat",
  "block.minecraft.banner.triangle_top.red": "Bou invertit roig",
  "block.minecraft.banner.triangle_top.white": "Bou invertit blanc",
  "block.minecraft.banner.triangle_top.yellow": "Bou invertit groc",
  "block.minecraft.banner.triangles_bottom.black": "Base dentada negra",
  "block.minecraft.banner.triangles_bottom.blue": "Base dentada blava",
  "block.minecraft.banner.triangles_bottom.brown": "Base dentada marró",
  "block.minecraft.banner.triangles_bottom.cyan": "Base dentada cian",
  "block.minecraft.banner.triangles_bottom.gray": "Base dentada grisa",
  "block.minecraft.banner.triangles_bottom.green": "Base dentada verda",
  "block.minecraft.banner.triangles_bottom.light_blue": "Base dentada blava clara",
  "block.minecraft.banner.triangles_bottom.light_gray": "Base dentada grisa clara",
  "block.minecraft.banner.triangles_bottom.lime": "Base dentada verda llima",
  "block.minecraft.banner.triangles_bottom.magenta": "Base dentada magenta",
  "block.minecraft.banner.triangles_bottom.orange": "Base dentada taronja",
  "block.minecraft.banner.triangles_bottom.pink": "Base dentada rosa",
  "block.minecraft.banner.triangles_bottom.purple": "Base dentada morada",
  "block.minecraft.banner.triangles_bottom.red": "Base dentada roja",
  "block.minecraft.banner.triangles_bottom.white": "Base dentada blanca",
  "block.minecraft.banner.triangles_bottom.yellow": "Base dentada groga",
  "block.minecraft.banner.triangles_top.black": "Cap dentat negre",
  "block.minecraft.banner.triangles_top.blue": "Cap dentat blau",
  "block.minecraft.banner.triangles_top.brown": "Cap dentat marró",
  "block.minecraft.banner.triangles_top.cyan": "Cap dentat cian",
  "block.minecraft.banner.triangles_top.gray": "Cap dentat gris",
  "block.minecraft.banner.triangles_top.green": "Cap dentat verd",
  "block.minecraft.banner.triangles_top.light_blue": "Cap dentat blau clar",
  "block.minecraft.banner.triangles_top.light_gray": "Cap dentat gris clar",
  "block.minecraft.banner.triangles_top.lime": "Cap dentat verd llima",
  "block.minecraft.banner.triangles_top.magenta": "Cap dentat magenta",
  "block.minecraft.banner.triangles_top.orange": "Cap dentat taronja",
  "block.minecraft.banner.triangles_top.pink": "Cap dentat rosa",
  "block.minecraft.banner.triangles_top.purple": "Cap dentat morat",
  "block.minecraft.banner.triangles_top.red": "Cap dentat roig",
  "block.minecraft.banner.triangles_top.white": "Cap dentat blanc",
  "block.minecraft.banner.triangles_top.yellow": "Cap dentat groc",
  "block.minecraft.barrel": "Barril",
  "block.minecraft.barrier": "Barrera",
  "block.minecraft.basalt": "Basalt",
  "block.minecraft.beacon": "Far màgic",
  "block.minecraft.beacon.primary": "Poder primari",
  "block.minecraft.beacon.secondary": "Poder secundari",
  "block.minecraft.bed.no_sleep": "Només pots dormir de nit o durant tronades",
  "block.minecraft.bed.not_safe": "No hauries de dormir ara: hi ha monstres per ací prop",
  "block.minecraft.bed.obstructed": "El llit està obstruït",
  "block.minecraft.bed.occupied": "Este llit està ocupat",
  "block.minecraft.bed.too_far_away": "No hauries de dormir ara: el llit està massa lluny",
  "block.minecraft.bedrock": "Roca base",
  "block.minecraft.bee_nest": "Rusc",
  "block.minecraft.beehive": "Buc",
  "block.minecraft.beetroots": "Remolatxes",
  "block.minecraft.bell": "Campana",
  "block.minecraft.big_dripleaf": "Fulla relliscosa gran",
  "block.minecraft.big_dripleaf_stem": "Tija de fulla relliscosa gran",
  "block.minecraft.birch_button": "Botó de bedoll",
  "block.minecraft.birch_door": "Porta de bedoll",
  "block.minecraft.birch_fence": "Tanca de bedoll",
  "block.minecraft.birch_fence_gate": "Porta de tanca de bedoll",
  "block.minecraft.birch_hanging_sign": "Cartell de bedoll penjant",
  "block.minecraft.birch_leaves": "Fulles de bedoll",
  "block.minecraft.birch_log": "Tronc de bedoll",
  "block.minecraft.birch_planks": "Taulons de bedoll",
  "block.minecraft.birch_pressure_plate": "Placa de pressió de bedoll",
  "block.minecraft.birch_sapling": "Esqueix de bedoll",
  "block.minecraft.birch_shelf": "Prestatgeria de bedoll",
  "block.minecraft.birch_sign": "Cartell de bedoll",
  "block.minecraft.birch_slab": "Llosa de bedoll",
  "block.minecraft.birch_stairs": "Escales de bedoll",
  "block.minecraft.birch_trapdoor": "Trapa de bedoll",
  "block.minecraft.birch_wall_hanging_sign": "Cartell de bedoll penjant de paret",
  "block.minecraft.birch_wall_sign": "Cartell de bedoll de paret",
  "block.minecraft.birch_wood": "Llenya de bedoll",
  "block.minecraft.black_banner": "Estandard negre",
  "block.minecraft.black_bed": "Llit negre",
  "block.minecraft.black_candle": "Ciri negre",
  "block.minecraft.black_candle_cake": "Pastís amb ciri negre",
  "block.minecraft.black_carpet": "Estora negra",
  "block.minecraft.black_concrete": "Formigó negre",
  "block.minecraft.black_concrete_powder": "Pols de formigó negre",
  "block.minecraft.black_glazed_terracotta": "Terracota glacejada negra",
  "block.minecraft.black_shulker_box": "Caixa de shulker negra",
  "block.minecraft.black_stained_glass": "Vidriera negra",
  "block.minecraft.black_stained_glass_pane": "Panell de vidriera negre",
  "block.minecraft.black_terracotta": "Terracota negra",
  "block.minecraft.black_wool": "Llana negra",
  "block.minecraft.blackstone": "Roca negra",
  "block.minecraft.blackstone_slab": "Llosa de roca negra",
  "block.minecraft.blackstone_stairs": "Escales de roca negra",
  "block.minecraft.blackstone_wall": "Mur de roca negra",
  "block.minecraft.blast_furnace": "Alt forn",
  "block.minecraft.blue_banner": "Estandard blau",
  "block.minecraft.blue_bed": "Llit blau",
  "block.minecraft.blue_candle": "Ciri blau",
  "block.minecraft.blue_candle_cake": "Pastís amb ciri blau",
  "block.minecraft.blue_carpet": "Estora blava",
  "block.minecraft.blue_concrete": "Formigó blau",
  "block.minecraft.blue_concrete_powder": "Pols de formigó blau",
  "block.minecraft.blue_glazed_terracotta": "Terracota glacejada blava",
  "block.minecraft.blue_ice": "Gel blau",
  "block.minecraft.blue_orchid": "Orquídia blava",
  "block.minecraft.blue_shulker_box": "Caixa de shulker blava",
  "block.minecraft.blue_stained_glass": "Vidriera blava",
  "block.minecraft.blue_stained_glass_pane": "Panell de vidriera blau",
  "block.minecraft.blue_terracotta": "Terracota blava",
  "block.minecraft.blue_wool": "Llana blava",
  "block.minecraft.bone_block": "Bloc d'os",
  "block.minecraft.bookshelf": "Llibreria",
  "block.minecraft.brain_coral": "Corall cerebral",
  "block.minecraft.brain_coral_block": "Bloc de corall cerebral",
  "block.minecraft.brain_coral_fan": "Gorgònia cerebral",
  "block.minecraft.brain_coral_wall_fan": "Gorgònia cerebral de paret",
  "block.minecraft.brewing_stand": "Altar de pocions",
  "block.minecraft.brick_slab": "Llosa de rajoles",
  "block.minecraft.brick_stairs": "Escales de rajoles",
  "block.minecraft.brick_wall": "Mur de rajoles",
  "block.minecraft.bricks": "Rajoles",
  "block.minecraft.brown_banner": "Estandard marró",
  "block.minecraft.brown_bed": "Llit marró",
  "block.minecraft.brown_candle": "Ciri marró",
  "block.minecraft.brown_candle_cake": "Pastís amb ciri marró",
  "block.minecraft.brown_carpet": "Estora marró",
  "block.minecraft.brown_concrete": "Formigó marró",
  "block.minecraft.brown_concrete_powder": "Pols de formigó marró",
  "block.minecraft.brown_glazed_terracotta": "Terracota glacejada marró",
  "block.minecraft.brown_mushroom": "Xampinyó marró",
  "block.minecraft.brown_mushroom_block": "Bloc de xampinyó marró",
  "block.minecraft.brown_shulker_box": "Caixa de shulker marró",
  "block.minecraft.brown_stained_glass": "Vidriera marró",
  "block.minecraft.brown_stained_glass_pane": "Panell de vidriera marró",
  "block.minecraft.brown_terracotta": "Terracota marró",
  "block.minecraft.brown_wool": "Llana marró",
  "block.minecraft.bubble_column": "Columna de bombolles",
  "block.minecraft.bubble_coral": "Corall de bombolles",
  "block.minecraft.bubble_coral_block": "Bloc de corall de bombolles",
  "block.minecraft.bubble_coral_fan": "Gorgònia de bombolles",
  "block.minecraft.bubble_coral_wall_fan": "Gorgònia de bombolles de paret",
  "block.minecraft.budding_amethyst": "Ametista incipient",
  "block.minecraft.bush": "Arbust",
  "block.minecraft.cactus": "Cactus",
  "block.minecraft.cactus_flower": "Flor de cactus",
  "block.minecraft.cake": "Pastís",
  "block.minecraft.calcite": "Calcita",
  "block.minecraft.calibrated_sculk_sensor": "Sensor de sculk calibrat",
  "block.minecraft.campfire": "Foguera",
  "block.minecraft.candle": "Ciri",
  "block.minecraft.candle_cake": "Ciri de pastís",
  "block.minecraft.carrots": "Carlotes",
  "block.minecraft.cartography_table": "Taula de cartografia",
  "block.minecraft.carved_pumpkin": "Carabassa tallada",
  "block.minecraft.cauldron": "Calderó",
  "block.minecraft.cave_air": "Aire de cova",
  "block.minecraft.cave_vines": "Lianes de cova",
  "block.minecraft.cave_vines_plant": "Planta de lianes de cova",
  "block.minecraft.chain": "Cadena",
  "block.minecraft.chain_command_block": "Bloc de comandaments encadenats",
  "block.minecraft.cherry_button": "Botó de cirerer",
  "block.minecraft.cherry_door": "Porta de cirerer",
  "block.minecraft.cherry_fence": "Tanca de cirerer",
  "block.minecraft.cherry_fence_gate": "Porta de tanca de cirerer",
  "block.minecraft.cherry_hanging_sign": "Cartell de cirerer penjant",
  "block.minecraft.cherry_leaves": "Fulles de cirerer",
  "block.minecraft.cherry_log": "Tronc de cirerer",
  "block.minecraft.cherry_planks": "Taulons de cirerer",
  "block.minecraft.cherry_pressure_plate": "Placa de pressió de cirerer",
  "block.minecraft.cherry_sapling": "Esqueix de cirerer",
  "block.minecraft.cherry_shelf": "Prestatgeria de cirerer",
  "block.minecraft.cherry_sign": "Cartell de cirerer",
  "block.minecraft.cherry_slab": "Llosa de cirerer",
  "block.minecraft.cherry_stairs": "Escales de cirerer",
  "block.minecraft.cherry_trapdoor": "Trapa de cirerer",
  "block.minecraft.cherry_wall_hanging_sign": "Cartell de cirerer penjant de paret",
  "block.minecraft.cherry_wall_sign": "Cartell de cirerer de paret",
  "block.minecraft.cherry_wood": "Llenya de cirerer",
  "block.minecraft.chest": "Cofre",
  "block.minecraft.chipped_anvil": "Enclusa esquerdada",
  "block.minecraft.chiseled_bookshelf": "Llibreria cisellada",
  "block.minecraft.chiseled_copper": "Coure cisellat",
  "block.minecraft.chiseled_deepslate": "Pissarra cisellada",
  "block.minecraft.chiseled_nether_bricks": "Rajoles del Nether cisellades",
  "block.minecraft.chiseled_polished_blackstone": "Roca negra polida cisellada",
  "block.minecraft.chiseled_quartz_block": "Bloc de quars cisellat",
  "block.minecraft.chiseled_red_sandstone": "Roca arenosa roja cisellada",
  "block.minecraft.chiseled_resin_bricks": "Rajoles de resina cisellades",
  "block.minecraft.chiseled_sandstone": "Roca arenosa cisellada",
  "block.minecraft.chiseled_stone_bricks": "Rajoles de roca cisellades",
  "block.minecraft.chiseled_tuff": "Tova volcànica cisellada",
  "block.minecraft.chiseled_tuff_bricks": "Rajoles de tova volcànica cisellada",
  "block.minecraft.chorus_flower": "Flor de coral",
  "block.minecraft.chorus_plant": "Coral",
  "block.minecraft.clay": "Argila",
  "block.minecraft.closed_eyeblossom": "Florull tancat",
  "block.minecraft.coal_block": "Bloc de carbó",
  "block.minecraft.coal_ore": "Mena de carbó",
  "block.minecraft.coarse_dirt": "Terra estèril",
  "block.minecraft.cobbled_deepslate": "Empedrat de pissarra",
  "block.minecraft.cobbled_deepslate_slab": "Llosa d'empedrat de pissarra",
  "block.minecraft.cobbled_deepslate_stairs": "Escales d'empedrat de pissarra",
  "block.minecraft.cobbled_deepslate_wall": "Mur d'empedrat de pissarra",
  "block.minecraft.cobblestone": "Empedrat",
  "block.minecraft.cobblestone_slab": "Llosa d'empedrat",
  "block.minecraft.cobblestone_stairs": "Escales d'empedrat",
  "block.minecraft.cobblestone_wall": "Mur d'empedrat",
  "block.minecraft.cobweb": "Teranyina",
  "block.minecraft.cocoa": "Cacau",
  "block.minecraft.command_block": "Bloc de comandaments",
  "block.minecraft.comparator": "Comparador de redstone",
  "block.minecraft.composter": "Compostador",
  "block.minecraft.conduit": "Canalitzador",
  "block.minecraft.copper_bars": "Reixa de coure",
  "block.minecraft.copper_block": "Bloc de coure",
  "block.minecraft.copper_bulb": "Làmpada de coure",
  "block.minecraft.copper_chain": "Cadena de coure",
  "block.minecraft.copper_chest": "Cofre de coure",
  "block.minecraft.copper_door": "Porta de coure",
  "block.minecraft.copper_golem_statue": "Estàtua de gólem de coure",
  "block.minecraft.copper_grate": "Reixeta de coure",
  "block.minecraft.copper_lantern": "Fanal de coure",
  "block.minecraft.copper_ore": "Mena de coure",
  "block.minecraft.copper_torch": "Torxa de coure",
  "block.minecraft.copper_trapdoor": "Trapa de coure",
  "block.minecraft.copper_wall_torch": "Torxa de coure de paret",
  "block.minecraft.cornflower": "Blauet",
  "block.minecraft.cracked_deepslate_bricks": "Rajoles de pissarra esquerdades",
  "block.minecraft.cracked_deepslate_tiles": "Taulells de pissarra esquerdats",
  "block.minecraft.cracked_nether_bricks": "Rajoles del Nether esquerdades",
  "block.minecraft.cracked_polished_blackstone_bricks": "Rajoles de roca negra polida esquerdades",
  "block.minecraft.cracked_stone_bricks": "Rajoles de roca esquerdades",
  "block.minecraft.crafter": "Fabricador",
  "block.minecraft.crafting_table": "Taula de manufactures",
  "block.minecraft.creaking_heart": "Cor de crepitant",
  "block.minecraft.creeper_head": "Cap de creeper",
  "block.minecraft.creeper_wall_head": "Cap de creeper de paret",
  "block.minecraft.crimson_button": "Botó de fusta carmesina",
  "block.minecraft.crimson_door": "Porta de fusta carmesina",
  "block.minecraft.crimson_fence": "Tanca carmesí",
  "block.minecraft.crimson_fence_gate": "Porta de tanca carmesí",
  "block.minecraft.crimson_fungus": "Fong carmesí",
  "block.minecraft.crimson_hanging_sign": "Cartell carmesí penjant",
  "block.minecraft.crimson_hyphae": "Hifa carmesí",
  "block.minecraft.crimson_nylium": "Miceli carmesí",
  "block.minecraft.crimson_planks": "Taulons de fusta carmesí",
  "block.minecraft.crimson_pressure_plate": "Placa de pressió carmesí",
  "block.minecraft.crimson_roots": "Arrels carmesines",
  "block.minecraft.crimson_shelf": "Prestatgeria carmesina",
  "block.minecraft.crimson_sign": "Cartell carmesí",
  "block.minecraft.crimson_slab": "Llosa carmesí",
  "block.minecraft.crimson_stairs": "Escales carmesí",
  "block.minecraft.crimson_stem": "Tija carmesina",
  "block.minecraft.crimson_trapdoor": "Trapa carmesí",
  "block.minecraft.crimson_wall_hanging_sign": "Cartell carmesí penjant de paret",
  "block.minecraft.crimson_wall_sign": "Cartell carmesí de paret",
  "block.minecraft.crying_obsidian": "Obsidiana plorosa",
  "block.minecraft.cut_copper": "Coure tallat",
  "block.minecraft.cut_copper_slab": "Llosa de coure tallat",
  "block.minecraft.cut_copper_stairs": "Escales de coure tallat",
  "block.minecraft.cut_red_sandstone": "Roca arenosa roja tallada",
  "block.minecraft.cut_red_sandstone_slab": "Llosa de roca arenosa roja tallada",
  "block.minecraft.cut_sandstone": "Roca arenosa tallada",
  "block.minecraft.cut_sandstone_slab": "Llosa de roca arenosa tallada",
  "block.minecraft.cyan_banner": "Estandard cian",
  "block.minecraft.cyan_bed": "Llit cian",
  "block.minecraft.cyan_candle": "Ciri cian",
  "block.minecraft.cyan_candle_cake": "Pastís amb ciri cian",
  "block.minecraft.cyan_carpet": "Estora cian",
  "block.minecraft.cyan_concrete": "Formigó cian",
  "block.minecraft.cyan_concrete_powder": "Pols de formigó cian",
  "block.minecraft.cyan_glazed_terracotta": "Terracota glacejada cian",
  "block.minecraft.cyan_shulker_box": "Caixa de shulker cian",
  "block.minecraft.cyan_stained_glass": "Vidriera cian",
  "block.minecraft.cyan_stained_glass_pane": "Panell de vidriera cian",
  "block.minecraft.cyan_terracotta": "Terracota cian",
  "block.minecraft.cyan_wool": "Llana cian",
  "block.minecraft.damaged_anvil": "Enclusa vella",
  "block.minecraft.dandelion": "Dent de lleó",
  "block.minecraft.dark_oak_button": "Botó de roure fosc",
  "block.minecraft.dark_oak_door": "Porta roure fosc",
  "block.minecraft.dark_oak_fence": "Tanca de roure fosc",
  "block.minecraft.dark_oak_fence_gate": "Porta de tanca de roure fosc",
  "block.minecraft.dark_oak_hanging_sign": "Cartell de roure fosc penjant",
  "block.minecraft.dark_oak_leaves": "Fulles de roure fosc",
  "block.minecraft.dark_oak_log": "Tronc de roure fosc",
  "block.minecraft.dark_oak_planks": "Taulons de roure fosc",
  "block.minecraft.dark_oak_pressure_plate": "Placa de pressió de roure fosc",
  "block.minecraft.dark_oak_sapling": "Esqueix de roure fosc",
  "block.minecraft.dark_oak_shelf": "Prestatgeria de roure fosc",
  "block.minecraft.dark_oak_sign": "Cartell de roure fosc",
  "block.minecraft.dark_oak_slab": "Llosa de roure fosc",
  "block.minecraft.dark_oak_stairs": "Escales de roure fosc",
  "block.minecraft.dark_oak_trapdoor": "Trapa de roure fosc",
  "block.minecraft.dark_oak_wall_hanging_sign": "Cartell de roure fosc penjant de paret",
  "block.minecraft.dark_oak_wall_sign": "Cartell de roure fosc de paret",
  "block.minecraft.dark_oak_wood": "Llenya de roure fosc",
  "block.minecraft.dark_prismarine": "Prismarina obscura",
  "block.minecraft.dark_prismarine_slab": "Llosa de prismarina obscura",
  "block.minecraft.dark_prismarine_stairs": "Escales de prismarina obscura",
  "block.minecraft.daylight_detector": "Sensor de llum solar",
  "block.minecraft.dead_brain_coral": "Corall cerebral mort",
  "block.minecraft.dead_brain_coral_block": "Bloc de corall cerebral mort",
  "block.minecraft.dead_brain_coral_fan": "Gorgònia cerebral morta",
  "block.minecraft.dead_brain_coral_wall_fan": "Gorgònia cerebral de paret morta",
  "block.minecraft.dead_bubble_coral": "Corall de bombolles mort",
  "block.minecraft.dead_bubble_coral_block": "Bloc de corall de bombolles mort",
  "block.minecraft.dead_bubble_coral_fan": "Gorgònia de bombolles morta",
  "block.minecraft.dead_bubble_coral_wall_fan": "Gorgònia de bombolles de paret morta",
  "block.minecraft.dead_bush": "Arbust mort",
  "block.minecraft.dead_fire_coral": "Corall de foc mort",
  "block.minecraft.dead_fire_coral_block": "Bloc de corall de foc mort",
  "block.minecraft.dead_fire_coral_fan": "Gorgònia de foc morta",
  "block.minecraft.dead_fire_coral_wall_fan": "Gorgònia de foc de paret morta",
  "block.minecraft.dead_horn_coral": "Corall de banya mort",
  "block.minecraft.dead_horn_coral_block": "Bloc de corall de banya mort",
  "block.minecraft.dead_horn_coral_fan": "Gorgònia de banya morta",
  "block.minecraft.dead_horn_coral_wall_fan": "Gorgònia de banya de paret morta",
  "block.minecraft.dead_tube_coral": "Corall de tub mort",
  "block.minecraft.dead_tube_coral_block": "Bloc de corall de tub mort",
  "block.minecraft.dead_tube_coral_fan": "Gorgònia de tub morta",
  "block.minecraft.dead_tube_coral_wall_fan": "Gorgònia de tub de paret morta",
  "block.minecraft.decorated_pot": "Gerro",
  "block.minecraft.deepslate": "Pissarra",
  "block.minecraft.deepslate_brick_slab": "Llosa de rajoles de pissarra",
  "block.minecraft.deepslate_brick_stairs": "Escales de rajoles de pissarra",
  "block.minecraft.deepslate_brick_wall": "Mur de rajoles de pissarra",
  "block.minecraft.deepslate_bricks": "Rajoles de pissarra",
  "block.minecraft.deepslate_coal_ore": "Mena de carbó pissarrosa",
  "block.minecraft.deepslate_copper_ore": "Mena de coure pissarrosa",
  "block.minecraft.deepslate_diamond_ore": "Mena de diamant pissarrosa",
  "block.minecraft.deepslate_emerald_ore": "Mena de maragda pissarrosa",
  "block.minecraft.deepslate_gold_ore": "Mena d'or pissarrosa",
  "block.minecraft.deepslate_iron_ore": "Mena de ferro pissarrosa",
  "block.minecraft.deepslate_lapis_ore": "Mena de lapislàtzuli pissarrosa",
  "block.minecraft.deepslate_redstone_ore": "Mena de redstone pissarrosa",
  "block.minecraft.deepslate_tile_slab": "Llosa de taulells de pissarra",
  "block.minecraft.deepslate_tile_stairs": "Escales de taulells de pissarra",
  "block.minecraft.deepslate_tile_wall": "Mur de taulells de pissarra",
  "block.minecraft.deepslate_tiles": "Taulells de pissarra",
  "block.minecraft.detector_rail": "Via detectora",
  "block.minecraft.diamond_block": "Bloc de diamant",
  "block.minecraft.diamond_ore": "Mena de diamant",
  "block.minecraft.diorite": "Diorita",
  "block.minecraft.diorite_slab": "Llosa de diorita",
  "block.minecraft.diorite_stairs": "Escales de diorita",
  "block.minecraft.diorite_wall": "Mur de diorita",
  "block.minecraft.dirt": "Terra",
  "block.minecraft.dirt_path": "Camí de terra",
  "block.minecraft.dispenser": "Dispensador",
  "block.minecraft.dragon_egg": "Ou del drac de la Fi",
  "block.minecraft.dragon_head": "Cap del drac",
  "block.minecraft.dragon_wall_head": "Cap del drac de paret",
  "block.minecraft.dried_ghast": "Ghast sec",
  "block.minecraft.dried_kelp_block": "Bloc d'algues seques",
  "block.minecraft.dripstone_block": "Bloc d'espeleotema",
  "block.minecraft.dropper": "Subministrador",
  "block.minecraft.emerald_block": "Bloc de maragda",
  "block.minecraft.emerald_ore": "Mena de maragda",
  "block.minecraft.enchanting_table": "Taula d'encanteris",
  "block.minecraft.end_gateway": "Porta de l'End",
  "block.minecraft.end_portal": "Portal a l'End",
  "block.minecraft.end_portal_frame": "Marc del portal a l'End",
  "block.minecraft.end_rod": "Vara de l'End",
  "block.minecraft.end_stone": "Roca de l'End",
  "block.minecraft.end_stone_brick_slab": "Llosa de rajoles de roca de l'End",
  "block.minecraft.end_stone_brick_stairs": "Escales de rajoles de roca de l'End",
  "block.minecraft.end_stone_brick_wall": "Mur de rajoles de roca de l'End",
  "block.minecraft.end_stone_bricks": "Rajoles de roca de l'End",
  "block.minecraft.ender_chest": "Cofre d'Ender",
  "block.minecraft.exposed_chiseled_copper": "Coure exposat cisellat",
  "block.minecraft.exposed_copper": "Coure exposat",
  "block.minecraft.exposed_copper_bars": "Reixa de coure exposat",
  "block.minecraft.exposed_copper_bulb": "Làmpada de coure exposat",
  "block.minecraft.exposed_copper_chain": "Cadena de coure exposat",
  "block.minecraft.exposed_copper_chest": "Cofre de coure exposat",
  "block.minecraft.exposed_copper_door": "Porta de coure exposat",
  "block.minecraft.exposed_copper_golem_statue": "Estátua de gólem de coure exposat",
  "block.minecraft.exposed_copper_grate": "Reixeta de coure exposat",
  "block.minecraft.exposed_copper_lantern": "Fanal de coure exposat",
  "block.minecraft.exposed_copper_trapdoor": "Trapa de coure exposat",
  "block.minecraft.exposed_cut_copper": "Coure tallat exposat",
  "block.minecraft.exposed_cut_copper_slab": "Llosa de coure tallat exposat",
  "block.minecraft.exposed_cut_copper_stairs": "Escales de coure tallat exposat",
  "block.minecraft.exposed_lightning_rod": "Parallamps exposat",
  "block.minecraft.farmland": "Terra arada",
  "block.minecraft.fern": "Falaguera",
  "block.minecraft.fire": "Foc",
  "block.minecraft.fire_coral": "Corall de foc",
  "block.minecraft.fire_coral_block": "Bloc de corall de foc",
  "block.minecraft.fire_coral_fan": "Gorgònia de foc",
  "block.minecraft.fire_coral_wall_fan": "Gorgònia de foc de paret",
  "block.minecraft.firefly_bush": "Arbust amb lluernes",
  "block.minecraft.fletching_table": "Taller de fletxes",
  "block.minecraft.flower_pot": "Test",
  "block.minecraft.flowering_azalea": "Azalea florent",
  "block.minecraft.flowering_azalea_leaves": "Fulles d'azalea florent",
  "block.minecraft.frogspawn": "Ous de granota",
  "block.minecraft.frosted_ice": "Gel glaçat",
  "block.minecraft.furnace": "Forn",
  "block.minecraft.gilded_blackstone": "Roca negra daurada",
  "block.minecraft.glass": "Vidre",
  "block.minecraft.glass_pane": "Panell de vidre",
  "block.minecraft.glow_lichen": "Liquen fosforescent",
  "block.minecraft.glowstone": "Roca brillant",
  "block.minecraft.gold_block": "Bloc d'or",
  "block.minecraft.gold_ore": "Mena d'or",
  "block.minecraft.golden_dandelion": "Dent de lleó daurat",
  "block.minecraft.granite": "Granit",
  "block.minecraft.granite_slab": "Llosa de granit",
  "block.minecraft.granite_stairs": "Escales de granit",
  "block.minecraft.granite_wall": "Mur de granit",
  "block.minecraft.grass": "Herba",
  "block.minecraft.grass_block": "Bloc d'herba",
  "block.minecraft.gravel": "Grava",
  "block.minecraft.gray_banner": "Estandard gris",
  "block.minecraft.gray_bed": "Llit gris",
  "block.minecraft.gray_candle": "Ciri gris",
  "block.minecraft.gray_candle_cake": "Pastís amb ciri gris",
  "block.minecraft.gray_carpet": "Estora grisa",
  "block.minecraft.gray_concrete": "Formigó gris",
  "block.minecraft.gray_concrete_powder": "Pols de formigó gris",
  "block.minecraft.gray_glazed_terracotta": "Terracota glacejada grisa",
  "block.minecraft.gray_shulker_box": "Caixa de shulker grisa",
  "block.minecraft.gray_stained_glass": "Vidriera grisa",
  "block.minecraft.gray_stained_glass_pane": "Panell de vidriera gris",
  "block.minecraft.gray_terracotta": "Terracota grisa",
  "block.minecraft.gray_wool": "Llana grisa",
  "block.minecraft.green_banner": "Estandard verd",
  "block.minecraft.green_bed": "Llit verd",
  "block.minecraft.green_candle": "Ciri verd",
  "block.minecraft.green_candle_cake": "Pastís amb ciri verd",
  "block.minecraft.green_carpet": "Estora verda",
  "block.minecraft.green_concrete": "Formigó verd",
  "block.minecraft.green_concrete_powder": "Pols de formigó verd",
  "block.minecraft.green_glazed_terracotta": "Terracota glacejada verda",
  "block.minecraft.green_shulker_box": "Caixa de shulker verda",
  "block.minecraft.green_stained_glass": "Vidriera verda",
  "block.minecraft.green_stained_glass_pane": "Panell de vidriera verd",
  "block.minecraft.green_terracotta": "Terracota verda",
  "block.minecraft.green_wool": "Llana verda",
  "block.minecraft.grindstone": "Mola",
  "block.minecraft.hanging_roots": "Arrels penjants",
  "block.minecraft.hay_block": "Bala de fenc",
  "block.minecraft.heavy_core": "Nucli dens",
  "block.minecraft.heavy_weighted_pressure_plate": "Placa de pressió per a pes elevat",
  "block.minecraft.honey_block": "Bloc de mel",
  "block.minecraft.honeycomb_block": "Bloc de bresca",
  "block.minecraft.hopper": "Tremuja",
  "block.minecraft.horn_coral": "Corall de banya",
  "block.minecraft.horn_coral_block": "Bloc de corall de banya",
  "block.minecraft.horn_coral_fan": "Gorgònia de banya",
  "block.minecraft.horn_coral_wall_fan": "Gorgònia de banya de paret",
  "block.minecraft.ice": "Gel",
  "block.minecraft.infested_chiseled_stone_bricks": "Rajoles de roca cisellades infestades",
  "block.minecraft.infested_cobblestone": "Empedrat infestat",
  "block.minecraft.infested_cracked_stone_bricks": "Rajoles de roca esquerdades infestades",
  "block.minecraft.infested_deepslate": "Pissarra infestada",
  "block.minecraft.infested_mossy_stone_bricks": "Rajoles de roca amb molsa infestades",
  "block.minecraft.infested_stone": "Roca infestada",
  "block.minecraft.infested_stone_bricks": "Rajoles de roca infestades",
  "block.minecraft.iron_bars": "Reixa de ferro",
  "block.minecraft.iron_block": "Bloc de ferro",
  "block.minecraft.iron_chain": "Cadena de ferro",
  "block.minecraft.iron_door": "Porta de ferro",
  "block.minecraft.iron_ore": "Mena de ferro",
  "block.minecraft.iron_trapdoor": "Trapa de ferro",
  "block.minecraft.jack_o_lantern": "Carabassa de Halloween",
  "block.minecraft.jigsaw": "Bloc de trencaclosques",
  "block.minecraft.jukebox": "Tocadiscs",
  "block.minecraft.jungle_button": "Botó de jungla",
  "block.minecraft.jungle_door": "Porta de jungla",
  "block.minecraft.jungle_fence": "Tanca de jungla",
  "block.minecraft.jungle_fence_gate": "Porta de tanca de jungla",
  "block.minecraft.jungle_hanging_sign": "Cartell de jungla penjant",
  "block.minecraft.jungle_leaves": "Fulles de jungla",
  "block.minecraft.jungle_log": "Tronc de jungla",
  "block.minecraft.jungle_planks": "Taulons de jungla",
  "block.minecraft.jungle_pressure_plate": "Placa de pressió de jungla",
  "block.minecraft.jungle_sapling": "Esqueix de jungla",
  "block.minecraft.jungle_shelf": "Prestatgeria de jungla",
  "block.minecraft.jungle_sign": "Cartell de jungla",
  "block.minecraft.jungle_slab": "Llosa de jungla",
  "block.minecraft.jungle_stairs": "Escales de jungla",
  "block.minecraft.jungle_trapdoor": "Trapa de jungla",
  "block.minecraft.jungle_wall_hanging_sign": "Cartell de jungla penjant de paret",
  "block.minecraft.jungle_wall_sign": "Cartell de jungla de paret",
  "block.minecraft.jungle_wood": "Llenya de jungla",
  "block.minecraft.kelp": "Alga",
  "block.minecraft.kelp_plant": "Esqueix d'alga",
  "block.minecraft.ladder": "Escala",
  "block.minecraft.lantern": "Fanal",
  "block.minecraft.lapis_block": "Bloc de lapislàtzuli",
  "block.minecraft.lapis_ore": "Mena de lapislàtzuli",
  "block.minecraft.large_amethyst_bud": "Brot d'ametista gran",
  "block.minecraft.large_fern": "Falaguera gran",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Calderó amb lava",
  "block.minecraft.leaf_litter": "Fulles seques",
  "block.minecraft.lectern": "Faristol",
  "block.minecraft.lever": "Palanca",
  "block.minecraft.light": "Llum",
  "block.minecraft.light_blue_banner": "Estandard blau clar",
  "block.minecraft.light_blue_bed": "Llit blau clar",
  "block.minecraft.light_blue_candle": "Ciri blau clar",
  "block.minecraft.light_blue_candle_cake": "Pastís amb ciri blau clar",
  "block.minecraft.light_blue_carpet": "Estora blava clara",
  "block.minecraft.light_blue_concrete": "Formigó blau clar",
  "block.minecraft.light_blue_concrete_powder": "Pols de formigó blau clar",
  "block.minecraft.light_blue_glazed_terracotta": "Terracota glacejada blava clara",
  "block.minecraft.light_blue_shulker_box": "Caixa de shulker blava clara",
  "block.minecraft.light_blue_stained_glass": "Vidriera blau clar",
  "block.minecraft.light_blue_stained_glass_pane": "Panell de vidriera blau clar",
  "block.minecraft.light_blue_terracotta": "Terracota blava clara",
  "block.minecraft.light_blue_wool": "Llana blava clara",
  "block.minecraft.light_gray_banner": "Estandard gris clar",
  "block.minecraft.light_gray_bed": "Llit gris clar",
  "block.minecraft.light_gray_candle": "Ciri gris clar",
  "block.minecraft.light_gray_candle_cake": "Pastís amb ciri gris clar",
  "block.minecraft.light_gray_carpet": "Estora grisa clara",
  "block.minecraft.light_gray_concrete": "Formigó gris clar",
  "block.minecraft.light_gray_concrete_powder": "Pols de formigó gris clar",
  "block.minecraft.light_gray_glazed_terracotta": "Terracota glacejada grisa clara",
  "block.minecraft.light_gray_shulker_box": "Caixa de shulker grisa clara",
  "block.minecraft.light_gray_stained_glass": "Vidriera grisa clara",
  "block.minecraft.light_gray_stained_glass_pane": "Panell de vidriera gris clar",
  "block.minecraft.light_gray_terracotta": "Terracota grisa clara",
  "block.minecraft.light_gray_wool": "Llana grisa clara",
  "block.minecraft.light_weighted_pressure_plate": "Placa de pressió per a pes lleuger",
  "block.minecraft.lightning_rod": "Parallamps",
  "block.minecraft.lilac": "Lilà",
  "block.minecraft.lily_of_the_valley": "Lliri de la Mare de Déu",
  "block.minecraft.lily_pad": "Nenúfar",
  "block.minecraft.lime_banner": "Estandard verd llima",
  "block.minecraft.lime_bed": "Llit verd llima",
  "block.minecraft.lime_candle": "Ciri verd llima",
  "block.minecraft.lime_candle_cake": "Pastís amb ciri verd llima",
  "block.minecraft.lime_carpet": "Estora verda llima",
  "block.minecraft.lime_concrete": "Formigó verd llima",
  "block.minecraft.lime_concrete_powder": "Pols de formigó verd llima",
  "block.minecraft.lime_glazed_terracotta": "Terracota glacejada verda llima",
  "block.minecraft.lime_shulker_box": "Caixa de shulker verda llima",
  "block.minecraft.lime_stained_glass": "Vidriera verd llima",
  "block.minecraft.lime_stained_glass_pane": "Panell de vidriera verd llima",
  "block.minecraft.lime_terracotta": "Terracota verda llima",
  "block.minecraft.lime_wool": "Llana verd llima",
  "block.minecraft.lodestone": "Imant",
  "block.minecraft.loom": "Teler",
  "block.minecraft.magenta_banner": "Estandard magenta",
  "block.minecraft.magenta_bed": "Llit magenta",
  "block.minecraft.magenta_candle": "Ciri magenta",
  "block.minecraft.magenta_candle_cake": "Pastís amb ciri magenta",
  "block.minecraft.magenta_carpet": "Estora magenta",
  "block.minecraft.magenta_concrete": "Formigó magenta",
  "block.minecraft.magenta_concrete_powder": "Pols de formigó magenta",
  "block.minecraft.magenta_glazed_terracotta": "Terracota glacejada magenta",
  "block.minecraft.magenta_shulker_box": "Caixa de shulker magenta",
  "block.minecraft.magenta_stained_glass": "Vidriera magenta",
  "block.minecraft.magenta_stained_glass_pane": "Panell de vidriera magenta",
  "block.minecraft.magenta_terracotta": "Terracota magenta",
  "block.minecraft.magenta_wool": "Llana magenta",
  "block.minecraft.magma_block": "Bloc de magma",
  "block.minecraft.mangrove_button": "Botó de mangle",
  "block.minecraft.mangrove_door": "Porta de mangle",
  "block.minecraft.mangrove_fence": "Tanca de mangle",
  "block.minecraft.mangrove_fence_gate": "Porta de tanca de mangle",
  "block.minecraft.mangrove_hanging_sign": "Cartell de mangle penjant",
  "block.minecraft.mangrove_leaves": "Fulles de mangle",
  "block.minecraft.mangrove_log": "Tronc de mangle",
  "block.minecraft.mangrove_planks": "Taulons de mangle",
  "block.minecraft.mangrove_pressure_plate": "Placa de pressió de mangle",
  "block.minecraft.mangrove_propagule": "Propàgul de mangle",
  "block.minecraft.mangrove_roots": "Arrels de mangle",
  "block.minecraft.mangrove_shelf": "Prestatgeria de mangle",
  "block.minecraft.mangrove_sign": "Cartell de mangle",
  "block.minecraft.mangrove_slab": "Llosa de mangle",
  "block.minecraft.mangrove_stairs": "Escales de mangle",
  "block.minecraft.mangrove_trapdoor": "Trapa de mangle",
  "block.minecraft.mangrove_wall_hanging_sign": "Cartell de mangle penjant de paret",
  "block.minecraft.mangrove_wall_sign": "Cartell de mangle de paret",
  "block.minecraft.mangrove_wood": "Llenya de mangle",
  "block.minecraft.medium_amethyst_bud": "Brot d'ametista mitjà",
  "block.minecraft.melon": "Meló d'Alger",
  "block.minecraft.melon_stem": "Tija de meló d'Alger",
  "block.minecraft.moss_block": "Bloc de molsa",
  "block.minecraft.moss_carpet": "Estora de molsa",
  "block.minecraft.mossy_cobblestone": "Empedrat amb molsa",
  "block.minecraft.mossy_cobblestone_slab": "Llosa d'empedrat amb molsa",
  "block.minecraft.mossy_cobblestone_stairs": "Escales d'empedrat amb molsa",
  "block.minecraft.mossy_cobblestone_wall": "Mur d'empedrat amb molsa",
  "block.minecraft.mossy_stone_brick_slab": "Llosa de rajoles de roca amb molsa",
  "block.minecraft.mossy_stone_brick_stairs": "Escales de rajoles de roca amb molsa",
  "block.minecraft.mossy_stone_brick_wall": "Mur de rajoles de roca amb molsa",
  "block.minecraft.mossy_stone_bricks": "Rajoles de roca amb molsa",
  "block.minecraft.moving_piston": "Pistó en moviment",
  "block.minecraft.mud": "Fang",
  "block.minecraft.mud_brick_slab": "Llosa de rajoles de fang",
  "block.minecraft.mud_brick_stairs": "Escales de rajoles de fang",
  "block.minecraft.mud_brick_wall": "Mur de rajoles de fang",
  "block.minecraft.mud_bricks": "Rajoles de fang",
  "block.minecraft.muddy_mangrove_roots": "Arrels de mangle enfangades",
  "block.minecraft.mushroom_stem": "Tija de xampinyó",
  "block.minecraft.mycelium": "Miceli",
  "block.minecraft.nether_brick_fence": "Tanca de rajoles del Nether",
  "block.minecraft.nether_brick_slab": "Llosa de rajoles del Nether",
  "block.minecraft.nether_brick_stairs": "Escales de rajoles del Nether",
  "block.minecraft.nether_brick_wall": "Mur de rajoles del Nether",
  "block.minecraft.nether_bricks": "Rajoles del Nether",
  "block.minecraft.nether_gold_ore": "Mena d'or del Nether",
  "block.minecraft.nether_portal": "Portal al Nether",
  "block.minecraft.nether_quartz_ore": "Mena de quars",
  "block.minecraft.nether_sprouts": "Brots del Nether",
  "block.minecraft.nether_wart": "Bolet del Nether",
  "block.minecraft.nether_wart_block": "Bloc de bolet del Nether",
  "block.minecraft.netherite_block": "Bloc de netherita",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Bloc musical",
  "block.minecraft.oak_button": "Botó de roure",
  "block.minecraft.oak_door": "Porta de roure",
  "block.minecraft.oak_fence": "Tanca de roure",
  "block.minecraft.oak_fence_gate": "Porta de tanca de roure",
  "block.minecraft.oak_hanging_sign": "Cartell de roure penjant",
  "block.minecraft.oak_leaves": "Fulles de roure",
  "block.minecraft.oak_log": "Tronc de roure",
  "block.minecraft.oak_planks": "Taulons de roure",
  "block.minecraft.oak_pressure_plate": "Placa de pressió de roure",
  "block.minecraft.oak_sapling": "Esqueix de roure",
  "block.minecraft.oak_shelf": "Prestatgeria de roure",
  "block.minecraft.oak_sign": "Cartell de roure",
  "block.minecraft.oak_slab": "Llosa de roure",
  "block.minecraft.oak_stairs": "Escales de roure",
  "block.minecraft.oak_trapdoor": "Trapa de roure",
  "block.minecraft.oak_wall_hanging_sign": "Cartell de roure penjant de paret",
  "block.minecraft.oak_wall_sign": "Cartell de roure de paret",
  "block.minecraft.oak_wood": "Llenya de roure",
  "block.minecraft.observer": "Observador",
  "block.minecraft.obsidian": "Obsidiana",
  "block.minecraft.ochre_froglight": "Granollum ocre",
  "block.minecraft.ominous_banner": "Estandard ominós",
  "block.minecraft.open_eyeblossom": "Florull obert",
  "block.minecraft.orange_banner": "Estandard taronja",
  "block.minecraft.orange_bed": "Llit taronja",
  "block.minecraft.orange_candle": "Ciri taronja",
  "block.minecraft.orange_candle_cake": "Pastís amb ciri taronja",
  "block.minecraft.orange_carpet": "Estora taronja",
  "block.minecraft.orange_concrete": "Formigó taronja",
  "block.minecraft.orange_concrete_powder": "Pols de formigó taronja",
  "block.minecraft.orange_glazed_terracotta": "Terracota glacejada taronja",
  "block.minecraft.orange_shulker_box": "Caixa de shulker taronja",
  "block.minecraft.orange_stained_glass": "Vidriera taronja",
  "block.minecraft.orange_stained_glass_pane": "Panell de vidriera taronja",
  "block.minecraft.orange_terracotta": "Terracota taronja",
  "block.minecraft.orange_tulip": "Tulipa taronja",
  "block.minecraft.orange_wool": "Llana taronja",
  "block.minecraft.oxeye_daisy": "Margarida",
  "block.minecraft.oxidized_chiseled_copper": "Coure oxidat cisellat",
  "block.minecraft.oxidized_copper": "Coure oxidat",
  "block.minecraft.oxidized_copper_bars": "Reixa de coure oxidat",
  "block.minecraft.oxidized_copper_bulb": "Làmpada de coure oxidat",
  "block.minecraft.oxidized_copper_chain": "Cadena de coure oxidat",
  "block.minecraft.oxidized_copper_chest": "Cofre de coure oxidat",
  "block.minecraft.oxidized_copper_door": "Porta de coure oxidat",
  "block.minecraft.oxidized_copper_golem_statue": "Estàtua de gólem de coure oxidat",
  "block.minecraft.oxidized_copper_grate": "Reixeta de coure oxidat",
  "block.minecraft.oxidized_copper_lantern": "Fanal de coure oxidat",
  "block.minecraft.oxidized_copper_trapdoor": "Trapa de coure oxidat",
  "block.minecraft.oxidized_cut_copper": "Coure tallat oxidat",
  "block.minecraft.oxidized_cut_copper_slab": "Llosa de coure tallat oxidat",
  "block.minecraft.oxidized_cut_copper_stairs": "Escales de coure tallat oxidat",
  "block.minecraft.oxidized_lightning_rod": "Parallamps oxidat",
  "block.minecraft.packed_ice": "Gel compacte",
  "block.minecraft.packed_mud": "Fang compacte",
  "block.minecraft.pale_hanging_moss": "Molsa tètrica penjant",
  "block.minecraft.pale_moss_block": "Bloc de molsa tètrica",
  "block.minecraft.pale_moss_carpet": "Estora de molsa tètrica",
  "block.minecraft.pale_oak_button": "Botó de roure tètric",
  "block.minecraft.pale_oak_door": "Porta de roure tètric",
  "block.minecraft.pale_oak_fence": "Tanca de roure tètric",
  "block.minecraft.pale_oak_fence_gate": "Porta de tanca de roure tètric",
  "block.minecraft.pale_oak_hanging_sign": "Cartell de roure tètric penjant",
  "block.minecraft.pale_oak_leaves": "Fulles de roure tètric",
  "block.minecraft.pale_oak_log": "Tronc de roure tètric",
  "block.minecraft.pale_oak_planks": "Taulons de roure tètric",
  "block.minecraft.pale_oak_pressure_plate": "Placa de pressió de roure tètric",
  "block.minecraft.pale_oak_sapling": "Esqueix de roure tètric",
  "block.minecraft.pale_oak_shelf": "Prestatgeria de roure tètric",
  "block.minecraft.pale_oak_sign": "Cartell de roure tètric",
  "block.minecraft.pale_oak_slab": "Llosa de roure tètric",
  "block.minecraft.pale_oak_stairs": "Escales de roure tètric",
  "block.minecraft.pale_oak_trapdoor": "Trapa de roure tètric",
  "block.minecraft.pale_oak_wall_hanging_sign": "Cartell de roure tètric penjant de paret",
  "block.minecraft.pale_oak_wall_sign": "Cartell de roure tètric de paret",
  "block.minecraft.pale_oak_wood": "Llenya de roure tètric",
  "block.minecraft.pearlescent_froglight": "Granollum perlescent",
  "block.minecraft.peony": "Peònia",
  "block.minecraft.petrified_oak_slab": "Llosa petrificada de roure",
  "block.minecraft.piglin_head": "Cap de piglin",
  "block.minecraft.piglin_wall_head": "Cap de piglin de paret",
  "block.minecraft.pink_banner": "Estandard rosa",
  "block.minecraft.pink_bed": "Llit rosa",
  "block.minecraft.pink_candle": "Ciri rosa",
  "block.minecraft.pink_candle_cake": "Pastís amb ciri rosa",
  "block.minecraft.pink_carpet": "Estora rosa",
  "block.minecraft.pink_concrete": "Formigó rosa",
  "block.minecraft.pink_concrete_powder": "Pols de formigó rosa",
  "block.minecraft.pink_glazed_terracotta": "Terracota glacejada rosa",
  "block.minecraft.pink_petals": "Pètals rosa",
  "block.minecraft.pink_shulker_box": "Caixa de shulker rosa",
  "block.minecraft.pink_stained_glass": "Vidriera rosa",
  "block.minecraft.pink_stained_glass_pane": "Panell de vidriera rosa",
  "block.minecraft.pink_terracotta": "Terracota rosa",
  "block.minecraft.pink_tulip": "Tulipa rosa",
  "block.minecraft.pink_wool": "Llana rosa",
  "block.minecraft.piston": "Pistó",
  "block.minecraft.piston_head": "Cap de pistó",
  "block.minecraft.pitcher_crop": "Cultiu de planta de gerra",
  "block.minecraft.pitcher_plant": "Planta de gerra",
  "block.minecraft.player_head": "Cap del jugador",
  "block.minecraft.player_head.named": "Cap de %s",
  "block.minecraft.player_wall_head": "Cap del jugador de paret",
  "block.minecraft.podzol": "Pinassa",
  "block.minecraft.pointed_dripstone": "Espeleotema punteguda",
  "block.minecraft.polished_andesite": "Andesita polida",
  "block.minecraft.polished_andesite_slab": "Llosa d'andesita polida",
  "block.minecraft.polished_andesite_stairs": "Escales d'andesita polida",
  "block.minecraft.polished_basalt": "Basalt polit",
  "block.minecraft.polished_blackstone": "Roca negra polida",
  "block.minecraft.polished_blackstone_brick_slab": "Llosa de rajoles de roca negra polida",
  "block.minecraft.polished_blackstone_brick_stairs": "Escales de rajoles de roca negra polida",
  "block.minecraft.polished_blackstone_brick_wall": "Mur de rajoles de roca negra polida",
  "block.minecraft.polished_blackstone_bricks": "Rajoles de roca negra polida",
  "block.minecraft.polished_blackstone_button": "Botó de roca negra polida",
  "block.minecraft.polished_blackstone_pressure_plate": "Placa de pressió de roca negra polida",
  "block.minecraft.polished_blackstone_slab": "Llosa de roca negra polida",
  "block.minecraft.polished_blackstone_stairs": "Escales de roca negra polida",
  "block.minecraft.polished_blackstone_wall": "Mur de roca negra polida",
  "block.minecraft.polished_deepslate": "Pissarra polida",
  "block.minecraft.polished_deepslate_slab": "Llosa de pissarra polida",
  "block.minecraft.polished_deepslate_stairs": "Escales de pissarra polida",
  "block.minecraft.polished_deepslate_wall": "Mur de pissarra polida",
  "block.minecraft.polished_diorite": "Diorita polida",
  "block.minecraft.polished_diorite_slab": "Llosa de diorita polida",
  "block.minecraft.polished_diorite_stairs": "Escales de diorita polida",
  "block.minecraft.polished_granite": "Granit polit",
  "block.minecraft.polished_granite_slab": "Llosa de granit polida",
  "block.minecraft.polished_granite_stairs": "Escales de granit polit",
  "block.minecraft.polished_tuff": "Tova volcànica polida",
  "block.minecraft.polished_tuff_slab": "Llosa de tova volcànica polida",
  "block.minecraft.polished_tuff_stairs": "Escales de tova volcànica polida",
  "block.minecraft.polished_tuff_wall": "Mur de tova volcànica polida",
  "block.minecraft.poppy": "Rosella",
  "block.minecraft.potatoes": "Creïlles",
  "block.minecraft.potted_acacia_sapling": "Test amb esqueix d'acàcia",
  "block.minecraft.potted_allium": "Test amb allium",
  "block.minecraft.potted_azalea_bush": "Test amb azalea",
  "block.minecraft.potted_azure_bluet": "Test amb houstonia caerulea",
  "block.minecraft.potted_bamboo": "Test amb bambú",
  "block.minecraft.potted_birch_sapling": "Test amb esqueix de bedoll",
  "block.minecraft.potted_blue_orchid": "Test amb orquídia blava",
  "block.minecraft.potted_brown_mushroom": "Test amb xampinyó marró",
  "block.minecraft.potted_cactus": "Test amb cactus",
  "block.minecraft.potted_cherry_sapling": "Test amb esqueix de cirerer",
  "block.minecraft.potted_closed_eyeblossom": "Test amb florull tancat",
  "block.minecraft.potted_cornflower": "Test amb blauet",
  "block.minecraft.potted_crimson_fungus": "Test amb fong carmesí",
  "block.minecraft.potted_crimson_roots": "Test amb arrels carmesines",
  "block.minecraft.potted_dandelion": "Test amb dent de lleó",
  "block.minecraft.potted_dark_oak_sapling": "Test amb esqueix de roure fosc",
  "block.minecraft.potted_dead_bush": "Test amb arbust mort",
  "block.minecraft.potted_fern": "Test amb falaguera",
  "block.minecraft.potted_flowering_azalea_bush": "Test amb azalea florent",
  "block.minecraft.potted_golden_dandelion": "Test amb dent de lleó daurat",
  "block.minecraft.potted_jungle_sapling": "Test amb esqueix de jungla",
  "block.minecraft.potted_lily_of_the_valley": "Test amb lliri de la Mare de Déu",
  "block.minecraft.potted_mangrove_propagule": "Test amb propàgul de mangle",
  "block.minecraft.potted_oak_sapling": "Test amb esqueix de roure",
  "block.minecraft.potted_open_eyeblossom": "Test amb florull obert",
  "block.minecraft.potted_orange_tulip": "Test amb tulipa taronja",
  "block.minecraft.potted_oxeye_daisy": "Test amb margarida",
  "block.minecraft.potted_pale_oak_sapling": "Test amb esqueix de roure tètric",
  "block.minecraft.potted_pink_tulip": "Test amb tulipa rosa",
  "block.minecraft.potted_poppy": "Test amb rosella",
  "block.minecraft.potted_red_mushroom": "Test amb xampinyó roig",
  "block.minecraft.potted_red_tulip": "Test amb tulipa roja",
  "block.minecraft.potted_spruce_sapling": "Test amb esqueix de pícea",
  "block.minecraft.potted_torchflower": "Test amb flamaflor",
  "block.minecraft.potted_warped_fungus": "Test amb fong estrambòtic",
  "block.minecraft.potted_warped_roots": "Test amb arrels estrambòtiques",
  "block.minecraft.potted_white_tulip": "Test amb tulipa blanca",
  "block.minecraft.potted_wither_rose": "Test amb rosa mústia",
  "block.minecraft.powder_snow": "Neu pols",
  "block.minecraft.powder_snow_cauldron": "Calderó amb neu pols",
  "block.minecraft.powered_rail": "Via d'accelaració",
  "block.minecraft.prismarine": "Prismarina",
  "block.minecraft.prismarine_brick_slab": "Llosa de rajoles de prismarina",
  "block.minecraft.prismarine_brick_stairs": "Escales de rajoles de prismarina",
  "block.minecraft.prismarine_bricks": "Rajoles de prismarina",
  "block.minecraft.prismarine_slab": "Llosa de prismarina",
  "block.minecraft.prismarine_stairs": "Escales de prismarina",
  "block.minecraft.prismarine_wall": "Mur de prismarina",
  "block.minecraft.pumpkin": "Carabassa",
  "block.minecraft.pumpkin_stem": "Tija de carabassa",
  "block.minecraft.purple_banner": "Estandard morat",
  "block.minecraft.purple_bed": "Llit morat",
  "block.minecraft.purple_candle": "Ciri morat",
  "block.minecraft.purple_candle_cake": "Pastís amb ciri morat",
  "block.minecraft.purple_carpet": "Estora morada",
  "block.minecraft.purple_concrete": "Formigó morat",
  "block.minecraft.purple_concrete_powder": "Pols de formigó morat",
  "block.minecraft.purple_glazed_terracotta": "Terracota glacejada morada",
  "block.minecraft.purple_shulker_box": "Caixa de shulker morada",
  "block.minecraft.purple_stained_glass": "Vidriera morada",
  "block.minecraft.purple_stained_glass_pane": "Panell de vidriera morat",
  "block.minecraft.purple_terracotta": "Terracota morada",
  "block.minecraft.purple_wool": "Llana morada",
  "block.minecraft.purpur_block": "Bloc de purpur",
  "block.minecraft.purpur_pillar": "Pilar de purpur",
  "block.minecraft.purpur_slab": "Llosa de purpur",
  "block.minecraft.purpur_stairs": "Escales de purpur",
  "block.minecraft.quartz_block": "Bloc de quars",
  "block.minecraft.quartz_bricks": "Rajoles de quars",
  "block.minecraft.quartz_pillar": "Pilar de quars",
  "block.minecraft.quartz_slab": "Llosa de quars",
  "block.minecraft.quartz_stairs": "Escales de quars",
  "block.minecraft.rail": "Via",
  "block.minecraft.raw_copper_block": "Bloc de mineral de coure",
  "block.minecraft.raw_gold_block": "Bloc de mineral d'or",
  "block.minecraft.raw_iron_block": "Bloc de mineral de ferro",
  "block.minecraft.red_banner": "Estandard roig",
  "block.minecraft.red_bed": "Llit roig",
  "block.minecraft.red_candle": "Ciri roig",
  "block.minecraft.red_candle_cake": "Pastís amb ciri roig",
  "block.minecraft.red_carpet": "Estora roja",
  "block.minecraft.red_concrete": "Formigó roig",
  "block.minecraft.red_concrete_powder": "Pols de formigó roig",
  "block.minecraft.red_glazed_terracotta": "Terracota glacejada roja",
  "block.minecraft.red_mushroom": "Xampinyó roig",
  "block.minecraft.red_mushroom_block": "Bloc de xampinyó roig",
  "block.minecraft.red_nether_brick_slab": "Llosa de rajoles del Nether roges",
  "block.minecraft.red_nether_brick_stairs": "Escales de rajoles del Nether roges",
  "block.minecraft.red_nether_brick_wall": "Mur de rajoles del Nether roges",
  "block.minecraft.red_nether_bricks": "Rajoles del Nether roges",
  "block.minecraft.red_sand": "Arena roja",
  "block.minecraft.red_sandstone": "Roca arenosa roja",
  "block.minecraft.red_sandstone_slab": "Llosa de roca arenosa roja",
  "block.minecraft.red_sandstone_stairs": "Escales de roca arenosa roja",
  "block.minecraft.red_sandstone_wall": "Mur de roca arenosa roja",
  "block.minecraft.red_shulker_box": "Caixa de shulker roja",
  "block.minecraft.red_stained_glass": "Vidriera roja",
  "block.minecraft.red_stained_glass_pane": "Panell de vidriera roig",
  "block.minecraft.red_terracotta": "Terracota roja",
  "block.minecraft.red_tulip": "Tulipa roja",
  "block.minecraft.red_wool": "Llana roja",
  "block.minecraft.redstone_block": "Bloc de redstone",
  "block.minecraft.redstone_lamp": "Làmpada de redstone",
  "block.minecraft.redstone_ore": "Mena de redstone",
  "block.minecraft.redstone_torch": "Torxa de redstone",
  "block.minecraft.redstone_wall_torch": "Torxa de redstone de paret",
  "block.minecraft.redstone_wire": "Cable de redstone",
  "block.minecraft.reinforced_deepslate": "Pissarra profunda reforçada",
  "block.minecraft.repeater": "Repetidor de redstone",
  "block.minecraft.repeating_command_block": "Bloc de comandaments de repetició",
  "block.minecraft.resin_block": "Bloc de resina",
  "block.minecraft.resin_brick_slab": "Llosa de rajoles de resina",
  "block.minecraft.resin_brick_stairs": "Escales de rajoles de resina",
  "block.minecraft.resin_brick_wall": "Mur de rajoles de resina",
  "block.minecraft.resin_bricks": "Rajoles de resina",
  "block.minecraft.resin_clump": "Resina",
  "block.minecraft.respawn_anchor": "Àncora de reaparició",
  "block.minecraft.rooted_dirt": "Terra amb arrels",
  "block.minecraft.rose_bush": "Roser",
  "block.minecraft.sand": "Arena",
  "block.minecraft.sandstone": "Roca arenosa",
  "block.minecraft.sandstone_slab": "Llosa de roca arenosa",
  "block.minecraft.sandstone_stairs": "Escales de roca arenosa",
  "block.minecraft.sandstone_wall": "Mur de roca arenosa",
  "block.minecraft.scaffolding": "Bastida",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Catalitzador de sculk",
  "block.minecraft.sculk_sensor": "Sensor de sculk",
  "block.minecraft.sculk_shrieker": "Sculk cridaner",
  "block.minecraft.sculk_vein": "Vena de sculk",
  "block.minecraft.sea_lantern": "Llanterna marina",
  "block.minecraft.sea_pickle": "Cogombre de mar",
  "block.minecraft.seagrass": "Herba marina",
  "block.minecraft.set_spawn": "S'ha establit el punt de reaparició",
  "block.minecraft.short_dry_grass": "Herba seca curta",
  "block.minecraft.short_grass": "Herba curta",
  "block.minecraft.shroomlight": "Bloc d'espores lluminoses",
  "block.minecraft.shulker_box": "Caixa de shulker",
  "block.minecraft.skeleton_skull": "Calavera d'esquelet",
  "block.minecraft.skeleton_wall_skull": "Calavera d'esquelet de paret",
  "block.minecraft.slime_block": "Bloc de llim",
  "block.minecraft.small_amethyst_bud": "Brot d'ametista xicotet",
  "block.minecraft.small_dripleaf": "Fulla relliscosa xicoteta",
  "block.minecraft.smithing_table": "Ferreria",
  "block.minecraft.smoker": "Fumador",
  "block.minecraft.smooth_basalt": "Basalt llis",
  "block.minecraft.smooth_quartz": "Bloc de quars llis",
  "block.minecraft.smooth_quartz_slab": "Llosa de quars llis",
  "block.minecraft.smooth_quartz_stairs": "Escales de quars llis",
  "block.minecraft.smooth_red_sandstone": "Roca arenosa roja llisa",
  "block.minecraft.smooth_red_sandstone_slab": "Llosa de roca arenosa roja llisa",
  "block.minecraft.smooth_red_sandstone_stairs": "Escales de roca arenosa roja llisa",
  "block.minecraft.smooth_sandstone": "Roca arenosa llisa",
  "block.minecraft.smooth_sandstone_slab": "Llosa de roca arenosa llisa",
  "block.minecraft.smooth_sandstone_stairs": "Escales de roca arenosa llisa",
  "block.minecraft.smooth_stone": "Roca llisa",
  "block.minecraft.smooth_stone_slab": "Llosa de roca llisa",
  "block.minecraft.sniffer_egg": "Ou de rastrejador",
  "block.minecraft.snow": "Neu",
  "block.minecraft.snow_block": "Bloc de neu",
  "block.minecraft.soul_campfire": "Foguera d'ànimes",
  "block.minecraft.soul_fire": "Foc d'ànimes",
  "block.minecraft.soul_lantern": "Fanal d'ànimes",
  "block.minecraft.soul_sand": "Arena d'ànimes",
  "block.minecraft.soul_soil": "Terra d'ànimes",
  "block.minecraft.soul_torch": "Torxa d'ànimes",
  "block.minecraft.soul_wall_torch": "Torxa d'ànimes de paret",
  "block.minecraft.spawn.not_valid": "No tens cap llit ni àncora de reaparició, o està obstruït/ïda",
  "block.minecraft.spawner": "Generador de monstres",
  "block.minecraft.spawner.desc1": "Interactua amb un generador de criatures:",
  "block.minecraft.spawner.desc2": "Definix el tipus de criatura",
  "block.minecraft.sponge": "Esponja",
  "block.minecraft.spore_blossom": "Flor d'espores",
  "block.minecraft.spruce_button": "Botó de pícea",
  "block.minecraft.spruce_door": "Porta de pícea",
  "block.minecraft.spruce_fence": "Tanca de pícea",
  "block.minecraft.spruce_fence_gate": "Porta de tanca de pícea",
  "block.minecraft.spruce_hanging_sign": "Cartell de pícea penjant",
  "block.minecraft.spruce_leaves": "Fulles de pícea",
  "block.minecraft.spruce_log": "Tronc de pícea",
  "block.minecraft.spruce_planks": "Taulons de pícea",
  "block.minecraft.spruce_pressure_plate": "Placa de pressió de pícea",
  "block.minecraft.spruce_sapling": "Esqueix de pícea",
  "block.minecraft.spruce_shelf": "Prestatgeria de pícea",
  "block.minecraft.spruce_sign": "Cartell de pícea",
  "block.minecraft.spruce_slab": "Llosa de pícea",
  "block.minecraft.spruce_stairs": "Escales de pícea",
  "block.minecraft.spruce_trapdoor": "Trapa de pícea",
  "block.minecraft.spruce_wall_hanging_sign": "Cartell de pícea penjant de paret",
  "block.minecraft.spruce_wall_sign": "Cartell de pícea de paret",
  "block.minecraft.spruce_wood": "Llenya de pícea",
  "block.minecraft.sticky_piston": "Pistó apegalós",
  "block.minecraft.stone": "Roca",
  "block.minecraft.stone_brick_slab": "Llosa de rajoles de roca",
  "block.minecraft.stone_brick_stairs": "Escales de rajoles de roca",
  "block.minecraft.stone_brick_wall": "Mur de rajoles de roca",
  "block.minecraft.stone_bricks": "Rajoles de roca",
  "block.minecraft.stone_button": "Botó de pedra",
  "block.minecraft.stone_pressure_plate": "Placa de pressió de pedra",
  "block.minecraft.stone_slab": "Llosa de roca",
  "block.minecraft.stone_stairs": "Escales de roca",
  "block.minecraft.stonecutter": "Tallapedra",
  "block.minecraft.stripped_acacia_log": "Tronc d'acàcia escorçat",
  "block.minecraft.stripped_acacia_wood": "Llenya d’acàcia escorçada",
  "block.minecraft.stripped_bamboo_block": "Bloc de bambú escorçat",
  "block.minecraft.stripped_birch_log": "Tronc de bedoll escorçat",
  "block.minecraft.stripped_birch_wood": "Llenya de bedoll escorçada",
  "block.minecraft.stripped_cherry_log": "Tronc de cirerer escorçat",
  "block.minecraft.stripped_cherry_wood": "Llenya de cirerer escorçada",
  "block.minecraft.stripped_crimson_hyphae": "Hifa carmesí escorçada",
  "block.minecraft.stripped_crimson_stem": "Tija carmesí escorçada",
  "block.minecraft.stripped_dark_oak_log": "Tronc de roure fosc escorçat",
  "block.minecraft.stripped_dark_oak_wood": "Llenya de roure fosc escorçada",
  "block.minecraft.stripped_jungle_log": "Tronc de jungla escorçat",
  "block.minecraft.stripped_jungle_wood": "Llenya de jungla escorçada",
  "block.minecraft.stripped_mangrove_log": "Tronc de mangle escorçat",
  "block.minecraft.stripped_mangrove_wood": "Llenya de mangle escorçada",
  "block.minecraft.stripped_oak_log": "Tronc de roure escorçat",
  "block.minecraft.stripped_oak_wood": "Llenya de roure escorçada",
  "block.minecraft.stripped_pale_oak_log": "Tronc de roure tètric escorçat",
  "block.minecraft.stripped_pale_oak_wood": "Llenya de roure tètric escorçada",
  "block.minecraft.stripped_spruce_log": "Tronc de pícea escorçat",
  "block.minecraft.stripped_spruce_wood": "Llenya de pícea escorçada",
  "block.minecraft.stripped_warped_hyphae": "Hifa estrambòtica escorçada",
  "block.minecraft.stripped_warped_stem": "Tija de fong estrambòtic escorçada",
  "block.minecraft.structure_block": "Bloc d'estructura",
  "block.minecraft.structure_void": "Estructura buida",
  "block.minecraft.sugar_cane": "Canya de sucre",
  "block.minecraft.sunflower": "Gira-sol",
  "block.minecraft.suspicious_gravel": "Grava sospitosa",
  "block.minecraft.suspicious_sand": "Arena sospitosa",
  "block.minecraft.sweet_berry_bush": "Esbarzer",
  "block.minecraft.tall_dry_grass": "Herba seca alta",
  "block.minecraft.tall_grass": "Herba alta",
  "block.minecraft.tall_seagrass": "Herba marina alta",
  "block.minecraft.target": "Diana",
  "block.minecraft.terracotta": "Terracota",
  "block.minecraft.test_block": "Bloc de proves",
  "block.minecraft.test_instance_block": "Bloc de proves d'instància",
  "block.minecraft.tinted_glass": "Vidre opac",
  "block.minecraft.tnt": "Explosius",
  "block.minecraft.tnt.disabled": "Les explosions de dinamita estan desactivades",
  "block.minecraft.torch": "Torxa",
  "block.minecraft.torchflower": "Flamaflor",
  "block.minecraft.torchflower_crop": "Cultiu de flamaflor",
  "block.minecraft.trapped_chest": "Cofre trampa",
  "block.minecraft.trial_spawner": "Generador de reptes",
  "block.minecraft.tripwire": "Corda",
  "block.minecraft.tripwire_hook": "Ganxo",
  "block.minecraft.tube_coral": "Corall de tub",
  "block.minecraft.tube_coral_block": "Bloc de corall de tub",
  "block.minecraft.tube_coral_fan": "Gorgònia de tub",
  "block.minecraft.tube_coral_wall_fan": "Gorgònia de tub de paret",
  "block.minecraft.tuff": "Tova volcànica",
  "block.minecraft.tuff_brick_slab": "Llosa de rajoles de tova volcànica",
  "block.minecraft.tuff_brick_stairs": "Escales de rajoles de tova volcànica",
  "block.minecraft.tuff_brick_wall": "Mur de rajoles de tova volcànica",
  "block.minecraft.tuff_bricks": "Rajoles de tova volcànica",
  "block.minecraft.tuff_slab": "Llosa de tova volcànica",
  "block.minecraft.tuff_stairs": "Escales de tova volcànica",
  "block.minecraft.tuff_wall": "Mur de tova volcànica",
  "block.minecraft.turtle_egg": "Ou de tortuga marina",
  "block.minecraft.twisting_vines": "Lianes estrambòtiques",
  "block.minecraft.twisting_vines_plant": "Lianes estrambòtiques",
  "block.minecraft.vault": "Caixa forta",
  "block.minecraft.verdant_froglight": "Granollum verda",
  "block.minecraft.vine": "Lianes",
  "block.minecraft.void_air": "Aire del buit",
  "block.minecraft.wall_torch": "Torxa de paret",
  "block.minecraft.warped_button": "Botó estrambòtic",
  "block.minecraft.warped_door": "Porta estrambòtica",
  "block.minecraft.warped_fence": "Tanca estrambòtica",
  "block.minecraft.warped_fence_gate": "Porta de tanca estrambòtica",
  "block.minecraft.warped_fungus": "Fong estrambòtic",
  "block.minecraft.warped_hanging_sign": "Cartell estrambòtic penjant",
  "block.minecraft.warped_hyphae": "Hifa estrambòtica",
  "block.minecraft.warped_nylium": "Miceli estrambòtic",
  "block.minecraft.warped_planks": "Taulons de fusta estrambòtica",
  "block.minecraft.warped_pressure_plate": "Placa de pressió estrambòtica",
  "block.minecraft.warped_roots": "Arrels estrambòtiques",
  "block.minecraft.warped_shelf": "Prestatgeria estrambòtica",
  "block.minecraft.warped_sign": "Cartell estrambòtic",
  "block.minecraft.warped_slab": "Llosa estrambòtica",
  "block.minecraft.warped_stairs": "Escales estrambòtiques",
  "block.minecraft.warped_stem": "Tija de fong estrambòtic",
  "block.minecraft.warped_trapdoor": "Trapa estrambòtica",
  "block.minecraft.warped_wall_hanging_sign": "Cartell estrambòtic penjant de paret",
  "block.minecraft.warped_wall_sign": "Cartell estrambòtic de paret",
  "block.minecraft.warped_wart_block": "Bloc de fong estrambòtic",
  "block.minecraft.water": "Aigua",
  "block.minecraft.water_cauldron": "Calderó amb aigua",
  "block.minecraft.waxed_chiseled_copper": "Coure cisellat encerat",
  "block.minecraft.waxed_copper_bars": "Reixa de coure encerat",
  "block.minecraft.waxed_copper_block": "Bloc de coure encerat",
  "block.minecraft.waxed_copper_bulb": "Làmpada de coure encerat",
  "block.minecraft.waxed_copper_chain": "Cadena de coure encerat",
  "block.minecraft.waxed_copper_chest": "Cofre de coure encerat",
  "block.minecraft.waxed_copper_door": "Porta de coure encerat",
  "block.minecraft.waxed_copper_golem_statue": "Estàtua de gólem de coure encerat",
  "block.minecraft.waxed_copper_grate": "Reixeta de coure encerat",
  "block.minecraft.waxed_copper_lantern": "Fanal de coure encerat",
  "block.minecraft.waxed_copper_trapdoor": "Trapa de coure encerat",
  "block.minecraft.waxed_cut_copper": "Coure tallat encerat",
  "block.minecraft.waxed_cut_copper_slab": "Llosa de coure tallat encerat",
  "block.minecraft.waxed_cut_copper_stairs": "Escales de coure tallat encerat",
  "block.minecraft.waxed_exposed_chiseled_copper": "Coure cisellat exposat encerat",
  "block.minecraft.waxed_exposed_copper": "Coure encerat exposat",
  "block.minecraft.waxed_exposed_copper_bars": "Reixa de coure exposat encerat",
  "block.minecraft.waxed_exposed_copper_bulb": "Làmpada de coure exposat encerat",
  "block.minecraft.waxed_exposed_copper_chain": "Cadena de coure exposat encerat",
  "block.minecraft.waxed_exposed_copper_chest": "Cofre de coure exposat encerat",
  "block.minecraft.waxed_exposed_copper_door": "Porta de coure exposat encerat",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Estàtua de gólem de coure exposat encerat",
  "block.minecraft.waxed_exposed_copper_grate": "Reixeta de coure exposat encerat",
  "block.minecraft.waxed_exposed_copper_lantern": "Fanal de coure exposat encerat",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Trapa de coure exposat encerat",
  "block.minecraft.waxed_exposed_cut_copper": "Coure tallat encerat exposat",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Llosa de coure tallat encerat exposat",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Escales de coure tallat encerat exposat",
  "block.minecraft.waxed_exposed_lightning_rod": "Parallamps exposat encerat",
  "block.minecraft.waxed_lightning_rod": "Parallamps encerat",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Coure cisellat oxidat encerat",
  "block.minecraft.waxed_oxidized_copper": "Coure oxidat encerat",
  "block.minecraft.waxed_oxidized_copper_bars": "Reixa de coure oxidat encerat",
  "block.minecraft.waxed_oxidized_copper_bulb": "Làmpada de coure oxidat encerat",
  "block.minecraft.waxed_oxidized_copper_chain": "Cadena de coure oxidat encerat",
  "block.minecraft.waxed_oxidized_copper_chest": "Cofre de coure oxidat encerat",
  "block.minecraft.waxed_oxidized_copper_door": "Porta de coure oxidat encerat",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Estàtua de gólem de coure oxidat encerat",
  "block.minecraft.waxed_oxidized_copper_grate": "Reixeta de coure oxidat encerat",
  "block.minecraft.waxed_oxidized_copper_lantern": "Fanal de coure oxidat encerat",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Trapa de coure oxidat encerat",
  "block.minecraft.waxed_oxidized_cut_copper": "Coure tallat oxidat encerat",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Llosa de coure tallat oxidat encerat",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Escales de coure tallat oxidat encerat",
  "block.minecraft.waxed_oxidized_lightning_rod": "Parallamps oxidat encerat",
  "block.minecraft.waxed_weathered_chiseled_copper": "Coure cisellat rovellat encerat",
  "block.minecraft.waxed_weathered_copper": "Coure encerat rovellat",
  "block.minecraft.waxed_weathered_copper_bars": "Reixa de coure rovellat encerat",
  "block.minecraft.waxed_weathered_copper_bulb": "Làmpada de coure rovellat encerat",
  "block.minecraft.waxed_weathered_copper_chain": "Cadena de coure rovellat encerat",
  "block.minecraft.waxed_weathered_copper_chest": "Cofre de coure rovellat encerat",
  "block.minecraft.waxed_weathered_copper_door": "Porta de coure rovellat encerat",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Estàtua de gólem de coure rovellat encerat",
  "block.minecraft.waxed_weathered_copper_grate": "Reixeta de coure rovellat encerat",
  "block.minecraft.waxed_weathered_copper_lantern": "Fanal de coure rovellat encerat",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Trapa de coure rovellat encerat",
  "block.minecraft.waxed_weathered_cut_copper": "Coure tallat encerat rovellat",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Llosa de coure tallat encerat rovellat",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Escales de coure tallat encerat rovellat",
  "block.minecraft.waxed_weathered_lightning_rod": "Parallamps rovellat encerat",
  "block.minecraft.weathered_chiseled_copper": "Coure cisellat rovellat",
  "block.minecraft.weathered_copper": "Coure rovellat",
  "block.minecraft.weathered_copper_bars": "Reixa de coure rovellat",
  "block.minecraft.weathered_copper_bulb": "Làmpada de coure rovellat",
  "block.minecraft.weathered_copper_chain": "Cadena de coure rovellat",
  "block.minecraft.weathered_copper_chest": "Cofre de coure rovellat",
  "block.minecraft.weathered_copper_door": "Porta de coure rovellat",
  "block.minecraft.weathered_copper_golem_statue": "Estàtua de gólem de coure rovellat",
  "block.minecraft.weathered_copper_grate": "Reixeta de coure rovellat",
  "block.minecraft.weathered_copper_lantern": "Fanal de coure rovellat",
  "block.minecraft.weathered_copper_trapdoor": "Trapa de coure rovellat",
  "block.minecraft.weathered_cut_copper": "Coure tallat rovellat",
  "block.minecraft.weathered_cut_copper_slab": "Llosa de coure tallat rovellada",
  "block.minecraft.weathered_cut_copper_stairs": "Escales de coure tallat rovellades",
  "block.minecraft.weathered_lightning_rod": "Parallamps rovellat",
  "block.minecraft.weeping_vines": "Lianes carmesines",
  "block.minecraft.weeping_vines_plant": "Lianes carmesines",
  "block.minecraft.wet_sponge": "Esponja humida",
  "block.minecraft.wheat": "Cultius de blat",
  "block.minecraft.white_banner": "Estandard blanc",
  "block.minecraft.white_bed": "Llit blanc",
  "block.minecraft.white_candle": "Ciri blanc",
  "block.minecraft.white_candle_cake": "Pastís amb ciri blanc",
  "block.minecraft.white_carpet": "Estora blanca",
  "block.minecraft.white_concrete": "Formigó blanc",
  "block.minecraft.white_concrete_powder": "Pols de formigó blanc",
  "block.minecraft.white_glazed_terracotta": "Terracota glacejada blanca",
  "block.minecraft.white_shulker_box": "Caixa de shulker blanca",
  "block.minecraft.white_stained_glass": "Vidriera blanca",
  "block.minecraft.white_stained_glass_pane": "Panell de vidriera blanc",
  "block.minecraft.white_terracotta": "Terracota blanca",
  "block.minecraft.white_tulip": "Tulipa blanca",
  "block.minecraft.white_wool": "Llana blanca",
  "block.minecraft.wildflowers": "Flors silvestres",
  "block.minecraft.wither_rose": "Rosa mústia",
  "block.minecraft.wither_skeleton_skull": "Calavera d'esquelet wither",
  "block.minecraft.wither_skeleton_wall_skull": "Calavera d'esquelet wither de paret",
  "block.minecraft.yellow_banner": "Estandard groc",
  "block.minecraft.yellow_bed": "Llit groc",
  "block.minecraft.yellow_candle": "Ciri groc",
  "block.minecraft.yellow_candle_cake": "Pastís amb ciri groc",
  "block.minecraft.yellow_carpet": "Estora groga",
  "block.minecraft.yellow_concrete": "Formigó groc",
  "block.minecraft.yellow_concrete_powder": "Pols de formigó groc",
  "block.minecraft.yellow_glazed_terracotta": "Terracota glacejada groga",
  "block.minecraft.yellow_shulker_box": "Caixa de shulker groga",
  "block.minecraft.yellow_stained_glass": "Vidriera groga",
  "block.minecraft.yellow_stained_glass_pane": "Panell de vidriera groc",
  "block.minecraft.yellow_terracotta": "Terracota groga",
  "block.minecraft.yellow_wool": "Llana groga",
  "block.minecraft.zombie_head": "Cap de zombi",
  "block.minecraft.zombie_wall_head": "Cap de zombi de paret",
  "item.minecraft.acacia_boat": "Barca d'acàcia",
  "item.minecraft.acacia_chest_boat": "Barca d'acàcia amb cofre",
  "item.minecraft.allay_spawn_egg": "Generar al·lai",
  "item.minecraft.amethyst_shard": "Fragment d'ametista",
  "item.minecraft.angler_pottery_shard": "Fragments de gerro de pescador",
  "item.minecraft.angler_pottery_sherd": "Fragments de gerro de pescador",
  "item.minecraft.apple": "Poma",
  "item.minecraft.archer_pottery_shard": "Fragments de gerro d'arquer",
  "item.minecraft.archer_pottery_sherd": "Fragments de gerro d'arquer",
  "item.minecraft.armadillo_scute": "Placa d'armadillo",
  "item.minecraft.armadillo_spawn_egg": "Generar armadillo",
  "item.minecraft.armor_stand": "Suport per a armadures",
  "item.minecraft.arms_up_pottery_shard": "Fragments de gerro de braços amunt",
  "item.minecraft.arms_up_pottery_sherd": "Fragments de gerro de braços amunt",
  "item.minecraft.arrow": "Fletxa",
  "item.minecraft.axolotl_bucket": "Poal amb axolot",
  "item.minecraft.axolotl_spawn_egg": "Generar axolot",
  "item.minecraft.baked_potato": "Creïlla torrada",
  "item.minecraft.bamboo_chest_raft": "Rai de bambú amb cofre",
  "item.minecraft.bamboo_raft": "Rai de bambú",
  "item.minecraft.bat_spawn_egg": "Generar ratpenat",
  "item.minecraft.bee_spawn_egg": "Generar abella",
  "item.minecraft.beef": "Bistec cru",
  "item.minecraft.beetroot": "Remolatxa",
  "item.minecraft.beetroot_seeds": "Llavors de remolatxa",
  "item.minecraft.beetroot_soup": "Sopa de remolatxa",
  "item.minecraft.birch_boat": "Barca de bedoll",
  "item.minecraft.birch_chest_boat": "Barca de bedoll amb cofre",
  "item.minecraft.black_bundle": "Saquet negre",
  "item.minecraft.black_dye": "Tint negre",
  "item.minecraft.black_harness": "Arnés negre",
  "item.minecraft.blade_pottery_shard": "Fragments de gerro de fil",
  "item.minecraft.blade_pottery_sherd": "Fragments de gerro de fil",
  "item.minecraft.blaze_powder": "Pols de foc",
  "item.minecraft.blaze_rod": "Vara flamejant",
  "item.minecraft.blaze_spawn_egg": "Generar Flama",
  "item.minecraft.blue_bundle": "Saquet blau",
  "item.minecraft.blue_dye": "Tint blau",
  "item.minecraft.blue_egg": "Ou blau",
  "item.minecraft.blue_harness": "Arnés blau",
  "item.minecraft.bogged_spawn_egg": "Generar esquelet empantanat",
  "item.minecraft.bolt_armor_trim_smithing_template": "Motle de ferreria",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Disseny d'armadura de caragol",
  "item.minecraft.bone": "Os",
  "item.minecraft.bone_meal": "Farina d'ossos",
  "item.minecraft.book": "Llibre",
  "item.minecraft.bordure_indented_banner_pattern": "Estandard amb bordura dentada",
  "item.minecraft.bow": "Arc de fletxes",
  "item.minecraft.bowl": "Bol",
  "item.minecraft.bread": "Pa",
  "item.minecraft.breeze_rod": "Vara de brisa",
  "item.minecraft.breeze_spawn_egg": "Generar brisa",
  "item.minecraft.brewer_pottery_shard": "Fragments de gerro d'alquimista",
  "item.minecraft.brewer_pottery_sherd": "Fragments de gerro d'alquimista",
  "item.minecraft.brewing_stand": "Altar de pocions",
  "item.minecraft.brick": "Rajola",
  "item.minecraft.brown_bundle": "Saquet marró",
  "item.minecraft.brown_dye": "Tint marró",
  "item.minecraft.brown_egg": "Ou marró",
  "item.minecraft.brown_harness": "Arnés marró",
  "item.minecraft.brush": "Raspall",
  "item.minecraft.bucket": "Poal",
  "item.minecraft.bundle": "Saquet",
  "item.minecraft.bundle.empty": "Buit",
  "item.minecraft.bundle.empty.description": "Pot contenir una pila mixta d'objectes",
  "item.minecraft.bundle.full": "Ple",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Fragments de gerro de foc",
  "item.minecraft.burn_pottery_sherd": "Fragments de gerro de foc",
  "item.minecraft.camel_husk_spawn_egg": "Generar dromedari momificat",
  "item.minecraft.camel_spawn_egg": "Generar dromedari",
  "item.minecraft.carrot": "Carlota",
  "item.minecraft.carrot_on_a_stick": "Carlota en un pal",
  "item.minecraft.cat_spawn_egg": "Generar gat",
  "item.minecraft.cauldron": "Calderó",
  "item.minecraft.cave_spider_spawn_egg": "Generar aranya de cova",
  "item.minecraft.chainmail_boots": "Botes de cota de malla",
  "item.minecraft.chainmail_chestplate": "Cuirassa de cota de malla",
  "item.minecraft.chainmail_helmet": "Casc de cota de malla",
  "item.minecraft.chainmail_leggings": "Malles de cota de malla",
  "item.minecraft.charcoal": "Carbó vegetal",
  "item.minecraft.cherry_boat": "Barca de cirerer",
  "item.minecraft.cherry_chest_boat": "Barca de cirerer amb cofre",
  "item.minecraft.chest_minecart": "Vagoneta amb cofre",
  "item.minecraft.chicken": "Pollastre cru",
  "item.minecraft.chicken_spawn_egg": "Generar gallina",
  "item.minecraft.chorus_fruit": "Fruit del coral",
  "item.minecraft.clay_ball": "Bola d'argila",
  "item.minecraft.clock": "Rellotge",
  "item.minecraft.coal": "Carbó",
  "item.minecraft.coast_armor_trim_smithing_template": "Motle de ferreria",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Disseny d'armadura de costa",
  "item.minecraft.cocoa_beans": "Grans de cacau",
  "item.minecraft.cod": "Abadejo cru",
  "item.minecraft.cod_bucket": "Poal amb abadejo",
  "item.minecraft.cod_spawn_egg": "Generar abadejo",
  "item.minecraft.command_block_minecart": "Vagoneta amb bloc de comandaments",
  "item.minecraft.compass": "Brúixola",
  "item.minecraft.cooked_beef": "Bistec torrat",
  "item.minecraft.cooked_chicken": "Pollastre torrat",
  "item.minecraft.cooked_cod": "Abadejo torrat",
  "item.minecraft.cooked_mutton": "Carn d'ovella torrada",
  "item.minecraft.cooked_porkchop": "Carn de porc torrada",
  "item.minecraft.cooked_rabbit": "Carn de conill torrada",
  "item.minecraft.cooked_salmon": "Salmó torrat",
  "item.minecraft.cookie": "Galeta",
  "item.minecraft.copper_axe": "Destral de coure",
  "item.minecraft.copper_boots": "Botes de coure",
  "item.minecraft.copper_chestplate": "Cuirassa de coure",
  "item.minecraft.copper_golem_spawn_egg": "Generar gólem de coure",
  "item.minecraft.copper_helmet": "Casc de coure",
  "item.minecraft.copper_hoe": "Aixada de coure",
  "item.minecraft.copper_horse_armor": "Armadura de coure per a cavalls",
  "item.minecraft.copper_ingot": "Lingot de coure",
  "item.minecraft.copper_leggings": "Malles de coure",
  "item.minecraft.copper_nautilus_armor": "Armadura de coure per a nautilus",
  "item.minecraft.copper_nugget": "Palleta de coure",
  "item.minecraft.copper_pickaxe": "Pic de coure",
  "item.minecraft.copper_shovel": "Pala de coure",
  "item.minecraft.copper_spear": "Llança de coure",
  "item.minecraft.copper_sword": "Espasa de coure",
  "item.minecraft.cow_spawn_egg": "Generar vaca",
  "item.minecraft.creaking_spawn_egg": "Generar crepitant",
  "item.minecraft.creeper_banner_pattern": "Estandard de creeper",
  "item.minecraft.creeper_banner_pattern.desc": "Estampat de creeper",
  "item.minecraft.creeper_banner_pattern.new": "Estandard de creeper carregat",
  "item.minecraft.creeper_spawn_egg": "Generar creeper",
  "item.minecraft.crossbow": "Ballesta",
  "item.minecraft.crossbow.projectile": "Projectil:",
  "item.minecraft.crossbow.projectile.multiple": "Projectil: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projectil: %s",
  "item.minecraft.cyan_bundle": "Saquet cian",
  "item.minecraft.cyan_dye": "Tint cian",
  "item.minecraft.cyan_harness": "Arnés cian",
  "item.minecraft.danger_pottery_shard": "Fragments de gerro de perill",
  "item.minecraft.danger_pottery_sherd": "Fragments de gerro de perill",
  "item.minecraft.dark_oak_boat": "Barca de roure fosc",
  "item.minecraft.dark_oak_chest_boat": "Barca de roure fosc amb cofre",
  "item.minecraft.debug_stick": "Pal de depuració",
  "item.minecraft.debug_stick.empty": "%s no té propietats",
  "item.minecraft.debug_stick.select": "s'ha seleccionat \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" ha canviat a %s",
  "item.minecraft.diamond": "Diamant",
  "item.minecraft.diamond_axe": "Destral de diamant",
  "item.minecraft.diamond_boots": "Botes de diamant",
  "item.minecraft.diamond_chestplate": "Cuirassa de diamant",
  "item.minecraft.diamond_helmet": "Casc de diamant",
  "item.minecraft.diamond_hoe": "Aixada de diamant",
  "item.minecraft.diamond_horse_armor": "Armadura de diamant per a cavalls",
  "item.minecraft.diamond_leggings": "Malles de diamant",
  "item.minecraft.diamond_nautilus_armor": "Armadura de diamant per a nautilus",
  "item.minecraft.diamond_pickaxe": "Pic de diamant",
  "item.minecraft.diamond_shovel": "Pala de diamant",
  "item.minecraft.diamond_spear": "Llança de diamant",
  "item.minecraft.diamond_sword": "Espasa de diamant",
  "item.minecraft.disc_fragment_5": "Fragment de disc",
  "item.minecraft.disc_fragment_5.desc": "Disc de música - 5",
  "item.minecraft.dolphin_spawn_egg": "Generar dofí",
  "item.minecraft.donkey_spawn_egg": "Generar ase",
  "item.minecraft.dragon_breath": "Alé de drac",
  "item.minecraft.dried_kelp": "Alga seca",
  "item.minecraft.drowned_spawn_egg": "Generar ofegat",
  "item.minecraft.dune_armor_trim_smithing_template": "Motle de ferreria",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Disseny d'armadura de duna",
  "item.minecraft.echo_shard": "Fragment ecoic",
  "item.minecraft.egg": "Ou",
  "item.minecraft.elder_guardian_spawn_egg": "Generar gran guardià de les profunditats",
  "item.minecraft.elytra": "Èlitres",
  "item.minecraft.emerald": "Maragda",
  "item.minecraft.enchanted_book": "Llibre encantat",
  "item.minecraft.enchanted_golden_apple": "Poma daurada encantada",
  "item.minecraft.end_crystal": "Cristall de l'End",
  "item.minecraft.ender_dragon_spawn_egg": "Generar drac d'Ender",
  "item.minecraft.ender_eye": "Ull d'Ender",
  "item.minecraft.ender_pearl": "Perla d'Ender",
  "item.minecraft.enderman_spawn_egg": "Generar enderman",
  "item.minecraft.endermite_spawn_egg": "Generar endermite",
  "item.minecraft.evoker_spawn_egg": "Generar evocador",
  "item.minecraft.experience_bottle": "Botella màgica",
  "item.minecraft.explorer_pottery_shard": "Fragments de gerro d'explorador",
  "item.minecraft.explorer_pottery_sherd": "Fragments de gerro d'explorador",
  "item.minecraft.eye_armor_trim_smithing_template": "Motle de ferreria",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Disseny d'armadura d'ull",
  "item.minecraft.feather": "Ploma",
  "item.minecraft.fermented_spider_eye": "Ull d'aranya fermentat",
  "item.minecraft.field_masoned_banner_pattern": "Estandard maçonat",
  "item.minecraft.filled_map": "Mapa",
  "item.minecraft.fire_charge": "Projectil de foc",
  "item.minecraft.firework_rocket": "Focs artificials",
  "item.minecraft.firework_rocket.flight": "Duració del vol:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Estrela de focs artificials",
  "item.minecraft.firework_star.black": "Negre",
  "item.minecraft.firework_star.blue": "Blau",
  "item.minecraft.firework_star.brown": "Marró",
  "item.minecraft.firework_star.custom_color": "Personalitzat",
  "item.minecraft.firework_star.cyan": "Cian",
  "item.minecraft.firework_star.fade_to": "Canviar a",
  "item.minecraft.firework_star.flicker": "Espurnejar",
  "item.minecraft.firework_star.gray": "Gris",
  "item.minecraft.firework_star.green": "Verd",
  "item.minecraft.firework_star.light_blue": "Blau clar",
  "item.minecraft.firework_star.light_gray": "Gris clar",
  "item.minecraft.firework_star.lime": "Verd llima",
  "item.minecraft.firework_star.magenta": "Magenta",
  "item.minecraft.firework_star.orange": "Taronja",
  "item.minecraft.firework_star.pink": "Rosa",
  "item.minecraft.firework_star.purple": "Morat",
  "item.minecraft.firework_star.red": "Roig",
  "item.minecraft.firework_star.shape": "Forma desconeguda",
  "item.minecraft.firework_star.shape.burst": "Explotar",
  "item.minecraft.firework_star.shape.creeper": "En forma de cara de creeper",
  "item.minecraft.firework_star.shape.large_ball": "Bola gran",
  "item.minecraft.firework_star.shape.small_ball": "Bola xicoteta",
  "item.minecraft.firework_star.shape.star": "En forma d'estrela",
  "item.minecraft.firework_star.trail": "Rastre",
  "item.minecraft.firework_star.white": "Blanc",
  "item.minecraft.firework_star.yellow": "Groc",
  "item.minecraft.fishing_rod": "Canya de pescar",
  "item.minecraft.flint": "Sílex",
  "item.minecraft.flint_and_steel": "Sílex i ferro",
  "item.minecraft.flow_armor_trim_smithing_template": "Motle de ferreria",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Disseny d'armadura de flux",
  "item.minecraft.flow_banner_pattern": "Estandard de flux",
  "item.minecraft.flow_banner_pattern.desc": "Flux",
  "item.minecraft.flow_banner_pattern.new": "Estandard de flux",
  "item.minecraft.flow_pottery_sherd": "Fragments de gerro de flux",
  "item.minecraft.flower_banner_pattern": "Estandard floral",
  "item.minecraft.flower_banner_pattern.desc": "Estampat de flors",
  "item.minecraft.flower_banner_pattern.new": "Estandard de flor",
  "item.minecraft.flower_pot": "Test",
  "item.minecraft.fox_spawn_egg": "Generar rabosa",
  "item.minecraft.friend_pottery_shard": "Fragments de gerro d'amic",
  "item.minecraft.friend_pottery_sherd": "Fragments de gerro d'amic",
  "item.minecraft.frog_spawn_egg": "Generar granota",
  "item.minecraft.furnace_minecart": "Vagoneta amb forn",
  "item.minecraft.ghast_spawn_egg": "Generar ghast",
  "item.minecraft.ghast_tear": "Llàgrima de ghast",
  "item.minecraft.glass_bottle": "Botella de vidre",
  "item.minecraft.glistering_melon_slice": "Rodanxa de meló d'Alger daurat",
  "item.minecraft.globe_banner_pattern": "Estandard planeta",
  "item.minecraft.globe_banner_pattern.desc": "Planeta",
  "item.minecraft.globe_banner_pattern.new": "Estandard de planeta",
  "item.minecraft.glow_berries": "Baies fosforescents",
  "item.minecraft.glow_ink_sac": "Sac de tinta fosforescent",
  "item.minecraft.glow_item_frame": "Marc fosforescent",
  "item.minecraft.glow_squid_spawn_egg": "Generar calamar fosforescent",
  "item.minecraft.glowstone_dust": "Pols de roca brillant",
  "item.minecraft.goat_horn": "Banya de cabra",
  "item.minecraft.goat_spawn_egg": "Generar cabra",
  "item.minecraft.gold_ingot": "Lingot d'or",
  "item.minecraft.gold_nugget": "Palleta d'or",
  "item.minecraft.golden_apple": "Poma d'or",
  "item.minecraft.golden_axe": "Destral d'or",
  "item.minecraft.golden_boots": "Botes d'or",
  "item.minecraft.golden_carrot": "Carlota d'or",
  "item.minecraft.golden_chestplate": "Cuirassa d'or",
  "item.minecraft.golden_helmet": "Casc d'or",
  "item.minecraft.golden_hoe": "Aixada d'or",
  "item.minecraft.golden_horse_armor": "Armadura d'or per a cavalls",
  "item.minecraft.golden_leggings": "Malles d'or",
  "item.minecraft.golden_nautilus_armor": "Armadura d'or per a nautilus",
  "item.minecraft.golden_pickaxe": "Pic d'or",
  "item.minecraft.golden_shovel": "Pala d'or",
  "item.minecraft.golden_spear": "Llança d'or",
  "item.minecraft.golden_sword": "Espasa d'or",
  "item.minecraft.gray_bundle": "Saquet gris",
  "item.minecraft.gray_dye": "Tint gris",
  "item.minecraft.gray_harness": "Arnés gris",
  "item.minecraft.green_bundle": "Saquet verd",
  "item.minecraft.green_dye": "Tint verd",
  "item.minecraft.green_harness": "Arnés verd",
  "item.minecraft.guardian_spawn_egg": "Generar guardià de les profunditats",
  "item.minecraft.gunpowder": "Pólvora",
  "item.minecraft.guster_banner_pattern": "Estandard de ràfega",
  "item.minecraft.guster_banner_pattern.desc": "Ràfega",
  "item.minecraft.guster_banner_pattern.new": "Estandard de ràfega",
  "item.minecraft.guster_pottery_sherd": "Fragments de gerro de ràfega",
  "item.minecraft.happy_ghast_spawn_egg": "Generar ghast feliç",
  "item.minecraft.harness": "Arnés",
  "item.minecraft.heart_of_the_sea": "El cor de la mar",
  "item.minecraft.heart_pottery_shard": "Fragments de gerro de cor",
  "item.minecraft.heart_pottery_sherd": "Fragments de gerro de cor",
  "item.minecraft.heartbreak_pottery_shard": "Fragments de gerro de cor trencat",
  "item.minecraft.heartbreak_pottery_sherd": "Fragments de gerro de cor trencat",
  "item.minecraft.hoglin_spawn_egg": "Generar hoglin",
  "item.minecraft.honey_bottle": "Botella de mel",
  "item.minecraft.honeycomb": "Bresca",
  "item.minecraft.hopper_minecart": "Vagoneta amb tremuja",
  "item.minecraft.horse_spawn_egg": "Generar cavall",
  "item.minecraft.host_armor_trim_smithing_template": "Motle de ferreria",
  "item.minecraft.host_armor_trim_smithing_template.new": "Disseny d'armadura d'hostatge",
  "item.minecraft.howl_pottery_shard": "Fragments de gerro d'udol",
  "item.minecraft.howl_pottery_sherd": "Fragments de gerro d'udol",
  "item.minecraft.husk_spawn_egg": "Generar mòmia",
  "item.minecraft.ink_sac": "Sac de tinta",
  "item.minecraft.iron_axe": "Destral de ferro",
  "item.minecraft.iron_boots": "Botes de ferro",
  "item.minecraft.iron_chestplate": "Cuirassa de ferro",
  "item.minecraft.iron_golem_spawn_egg": "Generar gólem de ferro",
  "item.minecraft.iron_helmet": "Casc de ferro",
  "item.minecraft.iron_hoe": "Aixada de ferro",
  "item.minecraft.iron_horse_armor": "Armadura de ferro per a cavalls",
  "item.minecraft.iron_ingot": "Lingot de ferro",
  "item.minecraft.iron_leggings": "Malles de ferro",
  "item.minecraft.iron_nautilus_armor": "Armadura de ferro per a nautilus",
  "item.minecraft.iron_nugget": "Palleta de ferro",
  "item.minecraft.iron_pickaxe": "Pic de ferro",
  "item.minecraft.iron_shovel": "Pala de ferro",
  "item.minecraft.iron_spear": "Llança de ferro",
  "item.minecraft.iron_sword": "Espasa de ferro",
  "item.minecraft.item_frame": "Marc",
  "item.minecraft.jungle_boat": "Barca de jungla",
  "item.minecraft.jungle_chest_boat": "Barca de jungla amb cofre",
  "item.minecraft.knowledge_book": "Enciclopèdia",
  "item.minecraft.lapis_lazuli": "Lapislàtzuli",
  "item.minecraft.lava_bucket": "Poal amb lava",
  "item.minecraft.lead": "Llaç",
  "item.minecraft.leather": "Cuir",
  "item.minecraft.leather_boots": "Botes de cuir",
  "item.minecraft.leather_chestplate": "Túnica de cuir",
  "item.minecraft.leather_helmet": "Casc de cuir",
  "item.minecraft.leather_horse_armor": "Armadura de cuir per a cavalls",
  "item.minecraft.leather_leggings": "Pantalons de cuir",
  "item.minecraft.light_blue_bundle": "Saquet blau clar",
  "item.minecraft.light_blue_dye": "Tint blau clar",
  "item.minecraft.light_blue_harness": "Arnés blau clar",
  "item.minecraft.light_gray_bundle": "Saquet gris clar",
  "item.minecraft.light_gray_dye": "Tint gris clar",
  "item.minecraft.light_gray_harness": "Arnés gris clar",
  "item.minecraft.lime_bundle": "Saquet verd llima",
  "item.minecraft.lime_dye": "Tint verd llima",
  "item.minecraft.lime_harness": "Arnés verd llima",
  "item.minecraft.lingering_potion": "Poció persistent",
  "item.minecraft.lingering_potion.effect.awkward": "Poció absurda persistent",
  "item.minecraft.lingering_potion.effect.empty": "Poció persistent no fabricable",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Poció persistent de resistència al foc",
  "item.minecraft.lingering_potion.effect.harming": "Poció persistent de dany",
  "item.minecraft.lingering_potion.effect.healing": "Poció persistent de curació",
  "item.minecraft.lingering_potion.effect.infested": "Poció persistent d'infestació",
  "item.minecraft.lingering_potion.effect.invisibility": "Poció persistent d'invisibilitat",
  "item.minecraft.lingering_potion.effect.leaping": "Poció persistent de salt",
  "item.minecraft.lingering_potion.effect.levitation": "Poció persistent de levitació",
  "item.minecraft.lingering_potion.effect.luck": "Poció persistent de sort",
  "item.minecraft.lingering_potion.effect.mundane": "Poció mundana persistent",
  "item.minecraft.lingering_potion.effect.night_vision": "Poció persistent de visió nocturna",
  "item.minecraft.lingering_potion.effect.oozing": "Poció persistent de supuració",
  "item.minecraft.lingering_potion.effect.poison": "Poció persistent verinosa",
  "item.minecraft.lingering_potion.effect.regeneration": "Poció persistent de regeneració",
  "item.minecraft.lingering_potion.effect.slow_falling": "Poció persistent de caiguda lenta",
  "item.minecraft.lingering_potion.effect.slowness": "Poció persistent de lentitud",
  "item.minecraft.lingering_potion.effect.strength": "Poció persistent de força",
  "item.minecraft.lingering_potion.effect.swiftness": "Poció persistent de velocitat",
  "item.minecraft.lingering_potion.effect.thick": "Poció densa persistent",
  "item.minecraft.lingering_potion.effect.turtle_master": "Poció persistent del Geni Tortuga",
  "item.minecraft.lingering_potion.effect.water": "Botella d'aigua persistent",
  "item.minecraft.lingering_potion.effect.water_breathing": "Poció persistent de respiració aquàtica",
  "item.minecraft.lingering_potion.effect.weakness": "Poció persistent de debilitat",
  "item.minecraft.lingering_potion.effect.weaving": "Poció persistent de teixidura",
  "item.minecraft.lingering_potion.effect.wind_charged": "Poció persistent de ventositat",
  "item.minecraft.llama_spawn_egg": "Generar llama",
  "item.minecraft.lodestone_compass": "Brúixola imantada",
  "item.minecraft.mace": "Maça",
  "item.minecraft.magenta_bundle": "Saquet magenta",
  "item.minecraft.magenta_dye": "Tint magenta",
  "item.minecraft.magenta_harness": "Arnés magenta",
  "item.minecraft.magma_cream": "Bola de magma",
  "item.minecraft.magma_cube_spawn_egg": "Generar cub de magma",
  "item.minecraft.mangrove_boat": "Barca de mangle",
  "item.minecraft.mangrove_chest_boat": "Barca de mangle amb cofre",
  "item.minecraft.map": "Mapa en blanc",
  "item.minecraft.melon_seeds": "Llavors de meló d'Alger",
  "item.minecraft.melon_slice": "Rodanxa de meló d'Alger",
  "item.minecraft.milk_bucket": "Poal amb llet",
  "item.minecraft.minecart": "Vagoneta",
  "item.minecraft.miner_pottery_shard": "Fragments de gerro de miner",
  "item.minecraft.miner_pottery_sherd": "Fragments de gerro de miner",
  "item.minecraft.mojang_banner_pattern": "Estandard de Mojang",
  "item.minecraft.mojang_banner_pattern.desc": "Cosa",
  "item.minecraft.mojang_banner_pattern.new": "Estandard de Mojang",
  "item.minecraft.mooshroom_spawn_egg": "Generar mooshroom",
  "item.minecraft.mourner_pottery_shard": "Fragments de gerro de dolent",
  "item.minecraft.mourner_pottery_sherd": "Fragments de gerro de dolent",
  "item.minecraft.mule_spawn_egg": "Generar mula",
  "item.minecraft.mushroom_stew": "Estofat de xampinyons",
  "item.minecraft.music_disc_11": "Disc de música",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Disc de música",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Disc de música",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Disc de música",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Disc de música",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Disc de música",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Disc de música",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Disc de música",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Music Box)",
  "item.minecraft.music_disc_far": "Disc de música",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Disc de música",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Disc de música",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Disc de música",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Disc de música",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Disc de música",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Disc de música",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Disc de música",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Disc de música",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Disc de música",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Disc de música",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Disc de música",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Disc de música",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Carn d'ovella crua",
  "item.minecraft.name_tag": "Etiqueta de nom",
  "item.minecraft.nautilus_shell": "Closca de nautilus",
  "item.minecraft.nautilus_spawn_egg": "Generar nautilus",
  "item.minecraft.nether_brick": "Rajola del Nether",
  "item.minecraft.nether_star": "Estrela del Nether",
  "item.minecraft.nether_wart": "Bolet del Nether",
  "item.minecraft.netherite_axe": "Destral de netherita",
  "item.minecraft.netherite_boots": "Botes de netherita",
  "item.minecraft.netherite_chestplate": "Cuirassa de netherita",
  "item.minecraft.netherite_helmet": "Casc de netherita",
  "item.minecraft.netherite_hoe": "Aixada de netherita",
  "item.minecraft.netherite_horse_armor": "Armadura de netherita per a cavalls",
  "item.minecraft.netherite_ingot": "Lingot de netherita",
  "item.minecraft.netherite_leggings": "Malles de netherita",
  "item.minecraft.netherite_nautilus_armor": "Armadura de netherita per a nautilus",
  "item.minecraft.netherite_pickaxe": "Pic de netherita",
  "item.minecraft.netherite_scrap": "Fragments de netherita",
  "item.minecraft.netherite_shovel": "Pala de netherita",
  "item.minecraft.netherite_spear": "Llança de netherita",
  "item.minecraft.netherite_sword": "Espasa de netherita",
  "item.minecraft.netherite_upgrade_smithing_template": "Motle de ferreria",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Millora de netherita",
  "item.minecraft.oak_boat": "Barca de roure",
  "item.minecraft.oak_chest_boat": "Barca de roure amb cofre",
  "item.minecraft.ocelot_spawn_egg": "Generar ocelot",
  "item.minecraft.ominous_bottle": "Botella ominosa",
  "item.minecraft.ominous_trial_key": "Clau de reptes ominosa",
  "item.minecraft.orange_bundle": "Saquet taronja",
  "item.minecraft.orange_dye": "Tint taronja",
  "item.minecraft.orange_harness": "Arnés taronja",
  "item.minecraft.painting": "Quadre",
  "item.minecraft.pale_oak_boat": "Barca de roure tètric",
  "item.minecraft.pale_oak_chest_boat": "Barca de roure tètric amb cofre",
  "item.minecraft.panda_spawn_egg": "Generar panda",
  "item.minecraft.paper": "Paper",
  "item.minecraft.parched_spawn_egg": "Generar esquelet de les arenes",
  "item.minecraft.parrot_spawn_egg": "Generar lloro",
  "item.minecraft.phantom_membrane": "Membrana d'ànima",
  "item.minecraft.phantom_spawn_egg": "Generar ànima",
  "item.minecraft.pig_spawn_egg": "Generar porc",
  "item.minecraft.piglin_banner_pattern": "Estandard de piglin",
  "item.minecraft.piglin_banner_pattern.desc": "Morro",
  "item.minecraft.piglin_banner_pattern.new": "Estandard de morro",
  "item.minecraft.piglin_brute_spawn_egg": "Generar piglin brut",
  "item.minecraft.piglin_spawn_egg": "Generar piglin",
  "item.minecraft.pillager_spawn_egg": "Generar bandit",
  "item.minecraft.pink_bundle": "Saquet rosa",
  "item.minecraft.pink_dye": "Tint rosa",
  "item.minecraft.pink_harness": "Arnés rosa",
  "item.minecraft.pitcher_plant": "Planta de gerra",
  "item.minecraft.pitcher_pod": "Baina de planta de gerra",
  "item.minecraft.plenty_pottery_shard": "Fragments de gerro de plenitud",
  "item.minecraft.plenty_pottery_sherd": "Fragments de gerro de plenitud",
  "item.minecraft.poisonous_potato": "Creïlla enverinada",
  "item.minecraft.polar_bear_spawn_egg": "Generar os polar",
  "item.minecraft.popped_chorus_fruit": "Fruit del coral esclafit",
  "item.minecraft.porkchop": "Carn de porc crua",
  "item.minecraft.potato": "Creïlla",
  "item.minecraft.potion": "Poció",
  "item.minecraft.potion.effect.awkward": "Poció absurda",
  "item.minecraft.potion.effect.empty": "Poció no fabricable",
  "item.minecraft.potion.effect.fire_resistance": "Poció de resistència ígnia",
  "item.minecraft.potion.effect.harming": "Poció de dany",
  "item.minecraft.potion.effect.healing": "Poció de curació",
  "item.minecraft.potion.effect.infested": "Poció d'infestació",
  "item.minecraft.potion.effect.invisibility": "Poció d'invisibilitat",
  "item.minecraft.potion.effect.leaping": "Poció de salt",
  "item.minecraft.potion.effect.levitation": "Poció de levitació",
  "item.minecraft.potion.effect.luck": "Poció de sort",
  "item.minecraft.potion.effect.mundane": "Poció sense efectes",
  "item.minecraft.potion.effect.night_vision": "Poció de visió nocturna",
  "item.minecraft.potion.effect.oozing": "Poció de supuració",
  "item.minecraft.potion.effect.poison": "Poció de verí",
  "item.minecraft.potion.effect.regeneration": "Poció de regeneració",
  "item.minecraft.potion.effect.slow_falling": "Poció de caiguda lenta",
  "item.minecraft.potion.effect.slowness": "Poció de lentitud",
  "item.minecraft.potion.effect.strength": "Poció de força",
  "item.minecraft.potion.effect.swiftness": "Poció de velocitat",
  "item.minecraft.potion.effect.thick": "Poció densa",
  "item.minecraft.potion.effect.turtle_master": "Poció del Geni Tortuga",
  "item.minecraft.potion.effect.water": "Botella d'aigua",
  "item.minecraft.potion.effect.water_breathing": "Poció de respiració aquàtica",
  "item.minecraft.potion.effect.weakness": "Poció de debilitat",
  "item.minecraft.potion.effect.weaving": "Poció de teixidura",
  "item.minecraft.potion.effect.wind_charged": "Poció de ventositat",
  "item.minecraft.pottery_shard_archer": "Fragment de ceràmica d'arquer",
  "item.minecraft.pottery_shard_arms_up": "Fragment de ceràmica de braços en alt",
  "item.minecraft.pottery_shard_prize": "Fragments de ceràmica de premi",
  "item.minecraft.pottery_shard_skull": "Fragment de ceràmica de calavera",
  "item.minecraft.powder_snow_bucket": "Poal amb neu pols",
  "item.minecraft.prismarine_crystals": "Cristalls de prismarina",
  "item.minecraft.prismarine_shard": "Fragment de prismarina",
  "item.minecraft.prize_pottery_shard": "Fragments de gerro de premi",
  "item.minecraft.prize_pottery_sherd": "Fragments de gerro de premi",
  "item.minecraft.pufferfish": "Peix globus",
  "item.minecraft.pufferfish_bucket": "Poal amb peix globus",
  "item.minecraft.pufferfish_spawn_egg": "Generar peix globus",
  "item.minecraft.pumpkin_pie": "Coca de carabassa",
  "item.minecraft.pumpkin_seeds": "Llavors de carabassa",
  "item.minecraft.purple_bundle": "Saquet morat",
  "item.minecraft.purple_dye": "Tint morat",
  "item.minecraft.purple_harness": "Arnés morat",
  "item.minecraft.quartz": "Quars",
  "item.minecraft.rabbit": "Carn de conill crua",
  "item.minecraft.rabbit_foot": "Pota de conill",
  "item.minecraft.rabbit_hide": "Pell de conill",
  "item.minecraft.rabbit_spawn_egg": "Generar conill",
  "item.minecraft.rabbit_stew": "Estofat de conill",
  "item.minecraft.raiser_armor_trim_smithing_template": "Motle de ferreria",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Disseny d'armadura d'elevació",
  "item.minecraft.ravager_spawn_egg": "Generar bèstia dels bandits",
  "item.minecraft.raw_copper": "Mineral de coure",
  "item.minecraft.raw_gold": "Mineral d'or",
  "item.minecraft.raw_iron": "Mineral de ferro",
  "item.minecraft.recovery_compass": "Brúixola de la troballa",
  "item.minecraft.red_bundle": "Saquet roig",
  "item.minecraft.red_dye": "Tint roig",
  "item.minecraft.red_harness": "Arnés roig",
  "item.minecraft.redstone": "Pols de redstone",
  "item.minecraft.resin_brick": "Rajola de resina",
  "item.minecraft.resin_clump": "Resina",
  "item.minecraft.rib_armor_trim_smithing_template": "Motle de ferreria",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Disseny d'armadura d'os",
  "item.minecraft.rotten_flesh": "Carn podrida",
  "item.minecraft.saddle": "Sella de muntar",
  "item.minecraft.salmon": "Salmó cru",
  "item.minecraft.salmon_bucket": "Poal amb salmó",
  "item.minecraft.salmon_spawn_egg": "Generar salmó",
  "item.minecraft.scrape_pottery_sherd": "Fragments de gerro d'arrap",
  "item.minecraft.scute": "Placa",
  "item.minecraft.sentry_armor_trim_smithing_template": "Motle de ferreria",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Disseny d'armadura de sentinella",
  "item.minecraft.shaper_armor_trim_smithing_template": "Motle de ferreria",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Disseny d'armadura de forma",
  "item.minecraft.sheaf_pottery_shard": "Fragments de gerro de feix",
  "item.minecraft.sheaf_pottery_sherd": "Fragments de gerro de feix",
  "item.minecraft.shears": "Tisores d'esquilar",
  "item.minecraft.sheep_spawn_egg": "Generar ovella",
  "item.minecraft.shelter_pottery_shard": "Fragments de gerro de refugi",
  "item.minecraft.shelter_pottery_sherd": "Fragments de gerro de refugi",
  "item.minecraft.shield": "Escut",
  "item.minecraft.shield.black": "Escut negre",
  "item.minecraft.shield.blue": "Escut blau",
  "item.minecraft.shield.brown": "Escut marró",
  "item.minecraft.shield.cyan": "Escut cian",
  "item.minecraft.shield.gray": "Escut gris",
  "item.minecraft.shield.green": "Escut verd",
  "item.minecraft.shield.light_blue": "Escut blau clar",
  "item.minecraft.shield.light_gray": "Escut gris clar",
  "item.minecraft.shield.lime": "Escut verd llima",
  "item.minecraft.shield.magenta": "Escut magenta",
  "item.minecraft.shield.orange": "Escut taronja",
  "item.minecraft.shield.pink": "Escut rosa",
  "item.minecraft.shield.purple": "Escut morat",
  "item.minecraft.shield.red": "Escut roig",
  "item.minecraft.shield.white": "Escut blanc",
  "item.minecraft.shield.yellow": "Escut groc",
  "item.minecraft.shulker_shell": "Closca de shulker",
  "item.minecraft.shulker_spawn_egg": "Generar shulker",
  "item.minecraft.sign": "Cartell",
  "item.minecraft.silence_armor_trim_smithing_template": "Motle de ferreria",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Disseny d'aramdura del silenci",
  "item.minecraft.silverfish_spawn_egg": "Generar peixet de plata",
  "item.minecraft.skeleton_horse_spawn_egg": "Generar cavall esquelètic",
  "item.minecraft.skeleton_spawn_egg": "Generar esquelet",
  "item.minecraft.skull_banner_pattern": "Estandard calavera",
  "item.minecraft.skull_banner_pattern.desc": "Estampat de calavera",
  "item.minecraft.skull_banner_pattern.new": "Estandard de calavera",
  "item.minecraft.skull_pottery_shard": "Fragments de gerro de calavera",
  "item.minecraft.skull_pottery_sherd": "Fragments de gerro de calavera",
  "item.minecraft.slime_ball": "Bola de Llim",
  "item.minecraft.slime_spawn_egg": "Generar cub de llim",
  "item.minecraft.smithing_template": "Motle de ferreria",
  "item.minecraft.smithing_template.applies_to": "S'aplica a:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Afig un lingot o cristall",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Armadura",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Afig una peça d'armadura",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Lingots i cristalls",
  "item.minecraft.smithing_template.ingredients": "Ingredients:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Afig un lingot de netherita",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Equipament de diamant",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Afig una armadura, arma o ferramenta de diamant",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Lingot de netherita",
  "item.minecraft.smithing_template.upgrade": "Millora: ",
  "item.minecraft.sniffer_spawn_egg": "Generar rastrejador",
  "item.minecraft.snort_pottery_shard": "Fragments de gerro de bufit",
  "item.minecraft.snort_pottery_sherd": "Fragments de gerro de bufit",
  "item.minecraft.snout_armor_trim_smithing_template": "Motle de ferreria",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Disseny d'armadura de morro",
  "item.minecraft.snow_golem_spawn_egg": "Generar gólem de neu",
  "item.minecraft.snowball": "Bola de neu",
  "item.minecraft.spectral_arrow": "Fletxa espectral",
  "item.minecraft.spider_eye": "Ull d'aranya",
  "item.minecraft.spider_spawn_egg": "Generar aranya",
  "item.minecraft.spire_armor_trim_smithing_template": "Motle de ferreria",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Disseny d'armadura de cúpula",
  "item.minecraft.splash_potion": "Poció explosiva",
  "item.minecraft.splash_potion.effect.awkward": "Poció explosiva absurda",
  "item.minecraft.splash_potion.effect.empty": "Poció explosiva no fabricable",
  "item.minecraft.splash_potion.effect.fire_resistance": "Poció explosiva de resistencia al foc",
  "item.minecraft.splash_potion.effect.harming": "Poció explosiva de dany",
  "item.minecraft.splash_potion.effect.healing": "Poció explosiva de curació",
  "item.minecraft.splash_potion.effect.infested": "Poció explosiva d'infestació",
  "item.minecraft.splash_potion.effect.invisibility": "Poció explosiva d'invisibilitat",
  "item.minecraft.splash_potion.effect.leaping": "Poció explosiva de salt",
  "item.minecraft.splash_potion.effect.levitation": "Poció explosiva de levitació",
  "item.minecraft.splash_potion.effect.luck": "Poció explosiva de sort",
  "item.minecraft.splash_potion.effect.mundane": "Poció explosiva mundana",
  "item.minecraft.splash_potion.effect.night_vision": "Poció explosiva de visió nocturna",
  "item.minecraft.splash_potion.effect.oozing": "Poció explosiva de supuració",
  "item.minecraft.splash_potion.effect.poison": "Poció explosiva de verí",
  "item.minecraft.splash_potion.effect.regeneration": "Poció explosiva de regeneració",
  "item.minecraft.splash_potion.effect.slow_falling": "Poció explosiva de caiguda lenta",
  "item.minecraft.splash_potion.effect.slowness": "Poció explosiva de lentitud",
  "item.minecraft.splash_potion.effect.strength": "Poció explosiva de força",
  "item.minecraft.splash_potion.effect.swiftness": "Poció explosiva de velocitat",
  "item.minecraft.splash_potion.effect.thick": "Poció explosiva densa",
  "item.minecraft.splash_potion.effect.turtle_master": "Poció explosiva del Geni Tortuga",
  "item.minecraft.splash_potion.effect.water": "Botella d'aigua explosiva",
  "item.minecraft.splash_potion.effect.water_breathing": "Poció explosiva de respiració aquàtica",
  "item.minecraft.splash_potion.effect.weakness": "Poció explosiva de debilitat",
  "item.minecraft.splash_potion.effect.weaving": "Poció explosiva de teixidura",
  "item.minecraft.splash_potion.effect.wind_charged": "Poció explosiva de ventositat",
  "item.minecraft.spruce_boat": "Barca de pícea",
  "item.minecraft.spruce_chest_boat": "Barca de pícea amb cofre",
  "item.minecraft.spyglass": "Ullera",
  "item.minecraft.squid_spawn_egg": "Generar calamar",
  "item.minecraft.stick": "Pal",
  "item.minecraft.stone_axe": "Destral de pedra",
  "item.minecraft.stone_hoe": "Aixada de pedra",
  "item.minecraft.stone_pickaxe": "Pic de pedra",
  "item.minecraft.stone_shovel": "Pala de pedra",
  "item.minecraft.stone_spear": "Llança de pedra",
  "item.minecraft.stone_sword": "Espasa de pedra",
  "item.minecraft.stray_spawn_egg": "Generar esquelet glacial",
  "item.minecraft.strider_spawn_egg": "Generar caminant",
  "item.minecraft.string": "Fil",
  "item.minecraft.sugar": "Sucre",
  "item.minecraft.suspicious_stew": "Estofat sospitós",
  "item.minecraft.sweet_berries": "Mores",
  "item.minecraft.tadpole_bucket": "Poal amb cullerot",
  "item.minecraft.tadpole_spawn_egg": "Generar cullerot",
  "item.minecraft.tide_armor_trim_smithing_template": "Motle de ferreria",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Disseny d'armadura de marea",
  "item.minecraft.tipped_arrow": "Fletxa amb efecte",
  "item.minecraft.tipped_arrow.effect.awkward": "Fletxa amb efecte",
  "item.minecraft.tipped_arrow.effect.empty": "Fletxa amb efecte impossible d'elaborar",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Fletxa de resistència ígnia",
  "item.minecraft.tipped_arrow.effect.harming": "Fletxa de dany augmentat",
  "item.minecraft.tipped_arrow.effect.healing": "Fletxa curativa",
  "item.minecraft.tipped_arrow.effect.infested": "Fletxa d'infestació",
  "item.minecraft.tipped_arrow.effect.invisibility": "Fletxa d'invisibilitat",
  "item.minecraft.tipped_arrow.effect.leaping": "Fletxa de salt",
  "item.minecraft.tipped_arrow.effect.levitation": "Fletxa de levitació",
  "item.minecraft.tipped_arrow.effect.luck": "Fletxa de la sort",
  "item.minecraft.tipped_arrow.effect.mundane": "Fletxa amb efecte",
  "item.minecraft.tipped_arrow.effect.night_vision": "Fletxa de visió nocturna",
  "item.minecraft.tipped_arrow.effect.oozing": "Fletxa de supuració",
  "item.minecraft.tipped_arrow.effect.poison": "Fletxa enverinada",
  "item.minecraft.tipped_arrow.effect.regeneration": "Fletxa de regeneració",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Fletxa de caiguda lenta",
  "item.minecraft.tipped_arrow.effect.slowness": "Fletxa de lentitud",
  "item.minecraft.tipped_arrow.effect.strength": "Fletxa de força",
  "item.minecraft.tipped_arrow.effect.swiftness": "Fletxa de velocitat",
  "item.minecraft.tipped_arrow.effect.thick": "Fletxa amb efecte",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Fletxa del Geni Tortuga",
  "item.minecraft.tipped_arrow.effect.water": "Fletxa esquitxadora",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Fletxa de respiració aquàtica",
  "item.minecraft.tipped_arrow.effect.weakness": "Fletxa de debilitat",
  "item.minecraft.tipped_arrow.effect.weaving": "Fletxa de teixidura",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Fletxa de ventositat",
  "item.minecraft.tnt_minecart": "Vagoneta amb explosius",
  "item.minecraft.torchflower_seeds": "Llavors de flamaflor",
  "item.minecraft.totem_of_undying": "Tòtem de la immortalitat",
  "item.minecraft.trader_llama_spawn_egg": "Generar llama de càrrega",
  "item.minecraft.trial_key": "Clau de reptes",
  "item.minecraft.trident": "Trident",
  "item.minecraft.tropical_fish": "Peix tropical",
  "item.minecraft.tropical_fish_bucket": "Poal amb peix tropical",
  "item.minecraft.tropical_fish_spawn_egg": "Generar peix tropical",
  "item.minecraft.turtle_helmet": "Closca de tortuga marina",
  "item.minecraft.turtle_scute": "Placa de tortuga",
  "item.minecraft.turtle_spawn_egg": "Generar tortuga marina",
  "item.minecraft.vex_armor_trim_smithing_template": "Motle de ferreria",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Disseny d'armadura d'esperit",
  "item.minecraft.vex_spawn_egg": "Generar esperit",
  "item.minecraft.villager_spawn_egg": "Generar vilatà",
  "item.minecraft.vindicator_spawn_egg": "Generar defensor",
  "item.minecraft.wandering_trader_spawn_egg": "Generar comerciant",
  "item.minecraft.ward_armor_trim_smithing_template": "Motle de ferreria",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Disseny d'armadura de guardià",
  "item.minecraft.warden_spawn_egg": "Generar castellà",
  "item.minecraft.warped_fungus_on_a_stick": "Fong estrambòtic en un pal",
  "item.minecraft.water_bucket": "Poal amb aigua",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Motle de ferreria",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Disseny d'armadura d'explorador",
  "item.minecraft.wheat": "Blat",
  "item.minecraft.wheat_seeds": "Llavors de blat",
  "item.minecraft.white_bundle": "Saquet blanc",
  "item.minecraft.white_dye": "Tint blanc",
  "item.minecraft.white_harness": "Arnés blanc",
  "item.minecraft.wild_armor_trim_smithing_template": "Motle de ferreria",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Disseny d'armadura salvatge",
  "item.minecraft.wind_charge": "Càrrega de vent",
  "item.minecraft.witch_spawn_egg": "Generar bruixa",
  "item.minecraft.wither_skeleton_spawn_egg": "Generar esquelet wither",
  "item.minecraft.wither_spawn_egg": "Generar wither",
  "item.minecraft.wolf_armor": "Armadura de llop",
  "item.minecraft.wolf_spawn_egg": "Generar llop",
  "item.minecraft.wooden_axe": "Destral de fusta",
  "item.minecraft.wooden_hoe": "Aixada de fusta",
  "item.minecraft.wooden_pickaxe": "Pic de fusta",
  "item.minecraft.wooden_shovel": "Pala de fusta",
  "item.minecraft.wooden_spear": "Llança de fusta",
  "item.minecraft.wooden_sword": "Espasa de fusta",
  "item.minecraft.writable_book": "Llibre, tinter i ploma",
  "item.minecraft.written_book": "Llibre escrit",
  "item.minecraft.yellow_bundle": "Saquet groc",
  "item.minecraft.yellow_dye": "Tint groc",
  "item.minecraft.yellow_harness": "Arnés groc",
  "item.minecraft.zoglin_spawn_egg": "Generar zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Generar cavall zombi",
  "item.minecraft.zombie_nautilus_spawn_egg": "Generar nautilus zombi",
  "item.minecraft.zombie_spawn_egg": "Generar zombi",
  "item.minecraft.zombie_villager_spawn_egg": "Generar vilatà zombi",
  "item.minecraft.zombified_piglin_spawn_egg": "Generar piglin zombi"
}
export const val_es = items; 
